/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface NoPermissionErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "NO_PERMISSION" */
    message: 'NO_PERMISSION';
}

export interface UnauthorisedErrorResponse {
    /** @example 401 */
    statusCode: 401;
    /** @example "UNAUTHORISED" */
    message: 'UNAUTHORISED';
}

export interface TokenExpiredErrorResponse {
    /** @example 401 */
    statusCode: 401;
    /** @example "TOKEN_EXPIRED" */
    message: 'TOKEN_EXPIRED';
}

export interface ValidationErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example ["email must be an email"] */
    message: string[];
    /** @example "Bad Request" */
    error: 'Bad Request';
}

export interface TasksAndAlertsAnalyticsTimeseriesItem {
    /** The timestamp of the start of the datapoint in YYYYMMDD format */
    st: string;
    /** The timestamp of the end of the data point in YYYYMMDD format */
    en?: string;
    /** The total number of tasks for the given timestamp */
    t?: number;
    /** The total number of alerts for the given timestamp */
    a?: number;
    /** The total number of false alarms for the given timestamp */
    fa?: number;
    /** The total number of real alarms for the given timestamp */
    ra?: number;
    /** The count of alerts of type Expired for the given timestamp */
    ate?: number;
    /** The count of alerts of type Manual for the given timestamp */
    atm?: number;
    /** The count of alerts of type Fall for the given timestamp */
    atf?: number;
    /** The count of alerts of type Geofence for the given timestamp */
    atg?: number;
    /** The count of alerts of type Tilt for the given timestamp */
    att?: number;
}

export interface TasksAndAnalyticsWeekdayItem {
    /** The total number of tasks for the given timestamp */
    t: number;
    /** The total number of alerts for the given timestamp */
    a: number;
}

export interface TasksAndAlertsAnalyticsWeek {
    mon: TasksAndAnalyticsWeekdayItem;
    tue: TasksAndAnalyticsWeekdayItem;
    wed: TasksAndAnalyticsWeekdayItem;
    thu: TasksAndAnalyticsWeekdayItem;
    fri: TasksAndAnalyticsWeekdayItem;
    sat: TasksAndAnalyticsWeekdayItem;
    sun: TasksAndAnalyticsWeekdayItem;
}

export interface GetTasksAndAlertsAnalyticsResponseData {
    /** The list of tasks and analytics data */
    timeseries: TasksAndAlertsAnalyticsTimeseriesItem[];
    /** The analytics data by weekday */
    week: TasksAndAlertsAnalyticsWeek;
    /** The from date in ISO format */
    from: string;
    /** The to date in ISO format */
    to: string;
    /**
     * The unit of time for the analytics data
     * @example "daily"
     */
    unit: 'daily' | 'weekly' | 'monthly';
}

export interface GetTasksAndAlertsAnalyticsResponse {
    data: GetTasksAndAlertsAnalyticsResponseData;
}

export interface GetTasksAndAlertsHourlyActivityAnalyticsResponseData {
    /** The list of task activity by the hour */
    tasks: number[][];
    /** The list of alert activity by the hour */
    alerts: number[][];
    /** The from date in ISO format */
    from: string;
    /** The to date in ISO format */
    to: string;
}

export interface GetTasksAndAlertsHourlyActivityAnalyticsResponse {
    data: GetTasksAndAlertsHourlyActivityAnalyticsResponseData;
}

export interface ActivityAnalyticsItem {
    /** The unique identifier of the item */
    itemId: string;
    /** The name of the item */
    itemName: string;
    /** The image URL of the item */
    itemImage: string;
    /** The count of tasks associated with the item */
    tasksCount: number;
    /** The count of alerts associated with the item */
    alertsCount: number;
}

export interface GetActivityAnalyticsResponseData {
    /** The activity items for the entities */
    items: ActivityAnalyticsItem[];
    /** The from date in ISO format */
    from: string;
    /** The to date in ISO format */
    to: string;
}

export interface GetActivityAnalyticsResponse {
    data: GetActivityAnalyticsResponseData;
}

export interface GetLocationAnalyticsResponseData {
    /**
     * The location analytics data.
     * @example [[51.5,-0.12],[52.1,-0.13]]
     */
    coordinates: number[][];
    /**
     * The next cursor for pagination.
     * @example "6315a5ed4c8edd17c30b2dc9="
     */
    nextCursor?: string;
    /**
     * The total number of location records to return. Only used if cursor is not provided.
     * @example 100
     */
    totalCoordinates?: number;
    /** The from date in ISO format */
    from: string;
    /** The to date in ISO format */
    to: string;
}

export interface GetLocationAnalyticsResponse {
    data: GetLocationAnalyticsResponseData;
}

export interface TooManyRequestsErrorResponse {
    /** @example 429 */
    statusCode: 429;
    /** @example "TOO_MANY_REQUESTS" */
    message: 'TOO_MANY_REQUESTS';
    /**
     * Seconds until the rate-limit window resets.
     * @example 60
     */
    retryAfter: number;
}

export interface AppCheckErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "APP_CHECK_FAILED" */
    message: 'APP_CHECK_FAILED';
}

export interface IpBlockedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "IP_BLOCKED" */
    message: 'IP_BLOCKED';
}

export interface InvalidTokenErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "INVALID_TOKEN" */
    message: 'INVALID_TOKEN';
}

export interface EmailBlockedErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "EMAIL_BLOCKED" */
    message: 'EMAIL_BLOCKED';
}

export interface UserAlreadyExistsErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "USER_ALREADY_EXISTS" */
    message: 'USER_ALREADY_EXISTS';
}

export interface SignupRequest {
    /**
     * The email address of the user. Legacy signup only: it creates the account with an unverified address. Omit it and send `token` instead.
     * @deprecated
     * @example "john.doe@example.com"
     */
    email?: string;
    /** The registration token returned by POST /v3/auth/signup/verify-email/confirm. The account is created against that (already verified) address, so `email` is not needed. Takes precedence if both are supplied. */
    token?: string;
    /** The users password. */
    password: string;
    /**
     * The users first name.
     * @example "James"
     */
    firstName: string;
    /**
     * The users last name.
     * @example "Rogers"
     */
    lastName: string;
    /**
     * The users agreement to the terms of service.
     * @example true
     */
    termsOfService: boolean;
    /**
     * The users agreement that they are over 16 years old.
     * @example true
     */
    over16: boolean;
    /**
     * The users agreement to the privacy policy.
     * @example true
     */
    privacyPolicy: boolean;
    /**
     * The users agreement to receive marketing material.
     * @example true
     */
    contactOptIn: boolean;
    /**
     * The users timezone (IANA timezone identifier).
     * @default "Europe/London"
     * @example "Europe/London"
     */
    timezone?: string;
}

export interface User {
    /**
     * The users id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The users email address.
     * @example "james@safepointapp.com"
     */
    email: string;
    /** Whether the users email is verified. */
    emailVerified: boolean;
    /**
     * Whether the user has PIN set.
     * @example true
     */
    hasPin: boolean;
    /**
     * Whether the user has a password set. False for an account created through SSO that has never set one. Such an account cannot change its email, password or PIN until it does, so send the user through the forgot-password flow first.
     * @example true
     */
    hasPassword: boolean;
}

export interface SignupResponseData {
    /** The user. */
    user: User;
    /** The access token. */
    accessToken: string;
    /** The refresh token. */
    refreshToken: string;
}

export interface SignupResponse {
    data: SignupResponseData;
}

export interface RequestSignupEmailVerificationRequest {
    /**
     * The email address to send the registration link to.
     * @example "john.doe@example.com"
     */
    email: string;
}

export interface IncorrectCodeErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "INCORRECT_CODE" */
    message: 'INCORRECT_CODE';
}

export interface TooManyCodeAttemptsErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "TOO_MANY_CODE_ATTEMPTS" */
    message: 'TOO_MANY_CODE_ATTEMPTS';
}

export interface ConfirmSignupEmailVerificationRequest {
    /**
     * The email address the code was sent to.
     * @example "john.doe@example.com"
     */
    email: string;
    /**
     * The 6 character code from the verification email. Case insensitive.
     * @example "K4T2WD"
     */
    code: string;
}

export interface ConfirmSignupEmailVerificationResponseData {
    /** The registration token. Send it as `token` to POST /v3/auth/signup to create the account against the now verified address. */
    token: string;
}

export interface ConfirmSignupEmailVerificationResponse {
    data: ConfirmSignupEmailVerificationResponseData;
}

export interface InvalidCredentialsErrorResponse {
    /** @example 401 */
    statusCode: 401;
    /** @example "INVALID_CREDENTIALS" */
    error: 'INVALID_CREDENTIALS';
    /** @example "Invalid credentials" */
    message: 'Invalid credentials';
    /**
     * Number of login attempts remaining before further requests are throttled.
     * @example 7
     */
    retriesRemaining: number;
    /**
     * Seconds until the rate-limit window resets.
     * @example 300
     */
    retryReset: number;
}

export interface LoginRequest {
    /**
     * The email address of the user.
     * @example "john.doe@example.com"
     */
    email: string;
    /** The users password. */
    password: string;
}

export interface LoginResponseData {
    /** The user. */
    user: User;
    /** The access token. */
    accessToken: string;
    /** The refresh token. */
    refreshToken: string;
}

export interface LoginResponse {
    data: LoginResponseData;
}

export interface SsoIdentityAlreadyLinkedErrorResponse {
    /** @example 409 */
    statusCode: 409;
    /** @example "SSO_IDENTITY_ALREADY_LINKED" */
    message: 'SSO_IDENTITY_ALREADY_LINKED';
}

export interface SsoEmailNotVerifiedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "SSO_EMAIL_NOT_VERIFIED" */
    message: 'SSO_EMAIL_NOT_VERIFIED';
}

export interface SsoAccountTypeNotSupportedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "SSO_ACCOUNT_TYPE_NOT_SUPPORTED" */
    message: 'SSO_ACCOUNT_TYPE_NOT_SUPPORTED';
}

export interface InvalidSsoTokenErrorResponse {
    /** @example 401 */
    statusCode: 401;
    /** @example "INVALID_SSO_TOKEN" */
    message: 'INVALID_SSO_TOKEN';
}

export interface ConsentRequiredErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CONSENT_REQUIRED" */
    message: 'CONSENT_REQUIRED';
}

export interface SsoProviderNotConfiguredErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "SSO_PROVIDER_NOT_CONFIGURED" */
    message: 'SSO_PROVIDER_NOT_CONFIGURED';
}

export interface SsoLoginRequest {
    /**
     * The identity provider that issued the ID token.
     * @example "google"
     */
    provider: 'google' | 'microsoft';
    /** The OIDC ID token from the provider SDK. This is the ID token, not the access token. */
    idToken: string;
    /** The nonce passed to the provider SDK, if one was used. When supplied it must match the token's nonce claim. */
    nonce?: string;
    /**
     * Consent to the terms of service. Only needed when the call will create an account — omit it when signing in. A call that would create an account without it returns 400 CONSENT_REQUIRED.
     * @example true
     */
    termsOfService?: boolean;
    /**
     * Consent to the privacy policy. See termsOfService.
     * @example true
     */
    privacyPolicy?: boolean;
    /**
     * Confirmation the user is over 16. See termsOfService.
     * @example true
     */
    over16?: boolean;
    /**
     * Marketing opt-in. Only read when the account is created; ignored on sign-in.
     * @default false
     * @example false
     */
    contactOptIn?: boolean;
    /**
     * IANA timezone. Only read when the account is created; ignored on sign-in.
     * @default "Europe/London"
     * @example "Europe/London"
     */
    timezone?: string;
}

export interface SsoLoginResponseData {
    /** The user. */
    user: User;
    /** The access token. */
    accessToken: string;
    /** The refresh token. */
    refreshToken: string;
    /**
     * Whether this call created the account. Route to onboarding when true, to the home screen when false.
     * @example false
     */
    created: boolean;
}

export interface SsoLoginResponse {
    data: SsoLoginResponseData;
}

export interface UserNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "USER_NOT_FOUND" */
    message: 'USER_NOT_FOUND';
}

export interface RefreshRequest {
    /** The refresh token. */
    refreshToken: string;
}

export interface RefreshResponseData {
    /** The access token. */
    accessToken: string;
}

export interface RefreshResponse {
    data: RefreshResponseData;
}

export interface LogoutRequest {
    /** The refresh token to revoke. */
    refreshToken: string;
}

export interface ForgotPasswordRequest {
    /**
     * The email address of the user.
     * @example "john.doe@example.com"
     */
    email: string;
}

export interface ResetPasswordRequest {
    /**
     * The password reset token.
     * @example "99IIUVvrI4Dyb9/XScmsZN1ZtUVfMiGU"
     */
    token: string;
    /** The users password. */
    password: string;
}

export interface IncorrectTokenErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "INCORRECT_TOKEN" */
    message: 'INCORRECT_TOKEN';
}

export interface VerifyEmailRequest {
    /** The email verification token. */
    token: string;
}

export interface CompanyNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "COMPANY_NOT_FOUND" */
    message: 'COMPANY_NOT_FOUND';
}

export interface NotSubscribedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "NOT_SUBSCRIBED" */
    message: 'NOT_SUBSCRIBED';
}

export interface NoSmsSubscriptionErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "NO_SMS_SUBSCRIPTION" */
    message: 'NO_SMS_SUBSCRIPTION';
}

export interface InvalidTeamErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "INVALID_TEAM" */
    message: 'INVALID_TEAM';
}

export interface SendBroadcastRequest {
    /**
     * The company id
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The team ids
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    teamIds: string[];
    /** The broadcast delivery methods */
    deliveryMethods: ('email' | 'app' | 'sms')[];
    /** The message to send. Minimum 1 character, maximum 500 characters. */
    message: string;
}

export interface CannotInviteYourselfErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_INVITE_YOURSELF" */
    message: 'CANNOT_INVITE_YOURSELF';
}

export interface DuplicateUsersErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "DUPLICATE_USERS" */
    message: 'DUPLICATE_USERS';
}

export interface CreateCompanyUserRequest {
    /** The users email. */
    email: string;
    /** The user company role */
    companyRole: 'owner' | 'admin' | 'billing' | 'member';
    /** The user team roles. */
    teamRoles: ('admin' | 'guardian')[];
}

export interface CreateCompanyRequest {
    /**
     * The company name.
     * @example "Acme Inc."
     */
    companyName: string;
    /**
     * The team name.
     * @example "Night Shift"
     */
    teamName?: string;
    /**
     * A contact phone number.
     * @example "+447808013499"
     */
    phone?: string;
    /** Array of users. */
    users: CreateCompanyUserRequest[];
    /** The GA client ID */
    analyticsClientId?: string;
}

export interface Subscription {
    /** The status of the subscription. */
    status:
        | 'active'
        | 'canceled'
        | 'incomplete'
        | 'incomplete_expired'
        | 'past_due'
        | 'paused'
        | 'trialing'
        | 'unpaid';
    /** The type of subscription. */
    type: 'STANDARD' | 'GUARDIAN_PLUS';
    /** The interval of the subscription. */
    interval: 'day' | 'month' | 'week' | 'year';
    /** The number of licenses included in the subscription. */
    quantity: number;
    /** The start of the subscription period in ISO format. */
    periodStart: string;
    /** The end of the subscription period in ISO format. */
    periodEnd: string;
    /** Whether the subscription is set to auto-renew. */
    cancelAtPeriodEnd: boolean;
    /** The collection method of the subscription. */
    collectionMethod: 'charge_automatically' | 'send_invoice';
}

export interface LWDSubscription {
    /** The status of the subscription. */
    status:
        | 'active'
        | 'canceled'
        | 'incomplete'
        | 'incomplete_expired'
        | 'past_due'
        | 'paused'
        | 'trialing'
        | 'unpaid';
    /** The interval of the subscription. */
    interval: 'day' | 'month' | 'week' | 'year';
    /** The number of licenses included in the subscription. */
    quantity: number;
    /** The number of tilt detection addons included. */
    tiltQuantity: number;
    /** The number of fall detection addons included. */
    fallQuantity: number;
    /** The number of geofence addons included. */
    geoQuantity: number;
    /** The start of the subscription period in ISO format. */
    periodStart: string;
    /** The end of the subscription period in ISO format. */
    periodEnd: string;
    /** Whether the subscription is set to auto-renew. */
    cancelAtPeriodEnd: boolean;
    /** The collection method of the subscription. */
    collectionMethod: 'charge_automatically' | 'send_invoice';
}

export interface SmsSubscription {
    /** The status of the subscription. */
    status:
        | 'active'
        | 'canceled'
        | 'incomplete'
        | 'incomplete_expired'
        | 'past_due'
        | 'paused'
        | 'trialing'
        | 'unpaid';
    /** The interval of the subscription. */
    interval: 'day' | 'month' | 'week' | 'year';
    /** The number of SMS credits included in the subscription. */
    creditsIncluded: number;
    /** The start of the subscription period in ISO format. */
    periodStart: string;
    /** The end of the subscription period in ISO format. */
    periodEnd: string;
    /** Whether the subscription is set to auto-renew. */
    cancelAtPeriodEnd: boolean;
    /** The collection method of the subscription. */
    collectionMethod: 'charge_automatically' | 'send_invoice';
}

export interface SMSUsageNotifications {
    /** The number of SMS credits used in the subscription. */
    usage: number;
    /** Whether the SMS usage notifications are enabled. */
    isEnabled: boolean;
}

export interface BillingNotifications {
    /** The SMS usage notifications details */
    smsUsage: SMSUsageNotifications;
}

export interface CompanyNotifications {
    /** The billing notifications details. */
    billing: BillingNotifications;
}

export interface CompanyFeatures {
    /** Whether the company can view LWD phone numbers. */
    canViewLWDPhone: boolean;
}

export interface Company {
    /**
     * The company id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The company name.
     * @example "ABC Company"
     */
    name: string;
    /** The company profile picture. */
    image: string;
    /** The company sector. */
    sector: string | null;
    /** The company subscription. */
    subscription: Subscription | null;
    /** The lwd subscription. */
    lwdSubscription: LWDSubscription | null;
    /** The company sms subscription. */
    smsSubscription: SmsSubscription | null;
    /** Is the app and LWD subscription bundled into one stripe subscription. */
    isStripeAppAndLWDSubscriptionBundled: boolean;
    /** The company notifications. */
    notifications: CompanyNotifications;
    /** The company features. */
    features: CompanyFeatures;
    /**
     * Whether the company is suspended.
     * @example false
     */
    suspended: boolean;
    /**
     * The date when the company was created in ISO format.
     * @example "2023-10-01T12:00:00Z"
     */
    createdAt: string;
}

export interface TeamSettings {
    /** Whether the PIN is enabled. */
    pinEnabled: boolean;
    /** Whether ARC is enabled. */
    arcEnabled: boolean;
    /** Whether out-of-hours contacts are enabled. */
    outOfHoursEnabled: boolean;
    /**
     * Minimum task duration in minutes.
     * @default 15
     */
    taskTimeMinMins: number;
    /**
     * Maximum task duration in minutes.
     * @default 1440
     */
    taskTimeMaxMins: number;
    /**
     * Task duration increment in minutes.
     * @default 15
     */
    taskTimeIncrementMins: number;
}

export interface Contact {
    /**
     * The contacts name
     * @example "James"
     */
    name: string;
    /**
     * The contacts role
     * @example "Manager"
     */
    role: string;
    /**
     * The contacts phone number
     * @example "+1234567890"
     */
    phone: string;
}

export interface ContactsScheduleDay {
    /** Whether this is a working day. */
    isWorkingDay: boolean;
    /** Whether working all day (no out-of-hours). */
    allDay?: boolean;
    /**
     * Start time of working hours in minutes of day (0-1439).
     * @min 0
     * @max 1439
     */
    startTime?: number;
    /**
     * End time of working hours in minutes of day (0-1439).
     * @min 0
     * @max 1439
     */
    endTime?: number;
}

export interface ContactsSchedule {
    /** Monday working hours configuration. */
    monday: ContactsScheduleDay;
    /** Tuesday working hours configuration. */
    tuesday: ContactsScheduleDay;
    /** Wednesday working hours configuration. */
    wednesday: ContactsScheduleDay;
    /** Thursday working hours configuration. */
    thursday: ContactsScheduleDay;
    /** Friday working hours configuration. */
    friday: ContactsScheduleDay;
    /** Saturday working hours configuration. */
    saturday: ContactsScheduleDay;
    /** Sunday working hours configuration. */
    sunday: ContactsScheduleDay;
}

export interface TeamNotification {
    /** Whether the notification is enabled for the app. */
    app: boolean;
    /** Whether the notification is enabled for SMS. */
    sms: boolean;
    /** Whether the notification is enabled for email. */
    email: boolean;
}

export interface TeamNotifications {
    /** The notification for when a task is started. */
    taskStarted: TeamNotification;
    /** The notification for when a task is extended. */
    taskExtended: TeamNotification;
    /** The notification for when a task is completed. */
    taskCompleted: TeamNotification;
    /** The notification for when a task has a note. */
    taskNote: TeamNotification;
    /** The notification for when an alert is triggered. */
    alertTriggered: TeamNotification;
    /** The notification for when an alert is assigned. */
    alertAssigned: TeamNotification;
    /** The notification for when an alert is unassigned. */
    alertUnassigned: TeamNotification;
    /** The notification for when an alert is resolved. */
    alertResolved: TeamNotification;
    /** The notification for when a team broadcast is sent. */
    teamBroadcast: TeamNotification;
}

export interface Procedure {
    /** The procedure step. */
    text: string;
}

export interface Team {
    /**
     * The team id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The company id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    companyId: string;
    /**
     * The team name.
     * @example "ABC Team"
     */
    name: string;
    /** The team profile picture. */
    image: string;
    /** The team settings. */
    settings: TeamSettings;
    /** The team contacts. */
    contacts: Contact[];
    /** The contacts working schedule. */
    contactsSchedule: ContactsSchedule | null;
    /** The out-of-hours escalation contacts. */
    outOfHoursContacts: Contact[];
    /**
     * The team timezone (IANA timezone string).
     * @example "Europe/London"
     */
    timezone: string;
    /** The team notifications. */
    notifications: TeamNotifications;
    /** The team procedures. */
    procedures: Procedure[];
}

export interface UserMedical {
    /**
     * The users blood type.
     * @example "male"
     */
    bloodType: string | null;
    /**
     * The users allergies.
     * @example ["Peanuts","Dairy"]
     */
    allergies: string[];
    /**
     * Any medical conditions the user has.
     * @example ["Diabetes","Asthma"]
     */
    conditions: string[];
    /**
     * Any medication the user is on.
     * @example ["Insulin","Ventolin"]
     */
    medication: string[];
}

export interface UserHeight {
    /**
     * The value
     * @example 180
     */
    value: number;
    /**
     * The unit
     * @example "CM"
     */
    unit: 'CM' | 'INCH';
}

export interface UserDescription {
    /** The users sex. */
    sex: string | null;
    /** The users dob. */
    dateOfBirth: string | null;
    /** The users race. */
    race: string | null;
    /** The users height. */
    height: UserHeight | null;
    /** The users hair colour. */
    hairColour: string | null;
    /** The users eye colour. */
    eyeColour: string | null;
    /**
     * Physical identifying of the user.
     * @example ["Scar on left arm","Tattoo on right arm"]
     */
    identifyingFeatures: string[];
    /** The users vehicle number plate. */
    vehicleNumberPlate: string | null;
}

export interface UserNotificationsSettingsItem {
    /**
     * The notification sound to play.
     * @example "default"
     */
    sound: string;
    /**
     * Whether to send critical notifications.
     * @example true
     */
    critical: boolean;
    /**
     * The critical notification volume. Value between 0-1.
     * @example 1
     */
    criticalVolume: number;
}

export interface UserNotificationsSettings {
    /** The task timeout notification. */
    taskTimeout: UserNotificationsSettingsItem;
    /** The tasks 5 minute reminder notification. */
    task5Min: UserNotificationsSettingsItem;
    /** The tasks 10 minute reminder notification. */
    task10Min: UserNotificationsSettingsItem;
}

export interface UserGuardianNotification {
    /** Whether the notification is enabled for the app. Null means the team setting applies. */
    app: boolean | null;
    /** Whether the notification is enabled for SMS. Null means the team setting applies. */
    sms: boolean | null;
    /** Whether the notification is enabled for email. Null means the team setting applies. */
    email: boolean | null;
}

export interface UserGuardianNotifications {
    /** The users preference for when a task is started. */
    taskStarted: UserGuardianNotification;
    /** The users preference for when a task is extended. */
    taskExtended: UserGuardianNotification;
    /** The users preference for when a task is completed. */
    taskCompleted: UserGuardianNotification;
    /** The users preference for when a task has a note. */
    taskNote: UserGuardianNotification;
    /** The users preference for when an alert is triggered. */
    alertTriggered: UserGuardianNotification;
    /** The users preference for when an alert is assigned. */
    alertAssigned: UserGuardianNotification;
    /** The users preference for when an alert is unassigned. */
    alertUnassigned: UserGuardianNotification;
    /** The users preference for when an alert is resolved. */
    alertResolved: UserGuardianNotification;
}

export interface TeamUserPermissions {
    /** Whether the user is an admin */
    isAdmin: boolean;
    /** Whether the user is a guardian */
    isGuardian: boolean;
}

export interface TeamUserRoleData {
    /** The team user role. */
    name: 'admin' | 'guardian';
    /** Whether the role is inherited. */
    inherited: boolean;
    /** The reason the role is inherited. */
    inheritedFrom: 'owner' | 'admin' | 'billing' | 'member' | null;
}

export interface CapabilityFlag {
    /** Whether the requesting user may perform this action on the member. */
    allowed: boolean;
    /** A stable reason code for why the action is denied. Present only when allowed is false. Clients that localize themselves should switch on this rather than the message. */
    code?:
        | 'NOT_PERMITTED'
        | 'SELF_NOT_ALLOWED'
        | 'OUTRANKS_YOU'
        | 'TEAM_NOT_VISIBLE'
        | null;
    /**
     * A human-readable, localized explanation of why the action is denied, suitable to show the user. Present only when allowed is false.
     * @example "This member has a higher role than you."
     */
    reason?: string | null;
}

export interface ViewerTeamCapabilities {
    /** Whether the requesting user can see this team. When false, the member is still listed but the team cannot be opened, and the management actions are denied for the same reason. */
    canView: CapabilityFlag;
    /** Whether the requesting user may change the member's roles within this team. */
    canManageRoles: CapabilityFlag;
    /** Whether the requesting user may remove the member from this team. */
    canRemove: CapabilityFlag;
}

export interface TeamUser {
    /**
     * The team id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    teamId: string;
    /**
     * The team name.
     * @example "Team 1"
     */
    name: string;
    /** The team image. */
    image: string;
    /** The users team permissions. */
    permissions: TeamUserPermissions;
    /** The users team role. */
    roles: TeamUserRoleData[];
    /** What the requesting user may do to this member within this team. */
    capabilities: ViewerTeamCapabilities;
}

export interface InvitedBy {
    /**
     * The user id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    userId: string;
    /**
     * The user email.
     * @example "james@safepointapp.com"
     */
    email: string;
    /**
     * The users first name.
     * @example "James"
     */
    firstName: string;
    /**
     * The users last name.
     * @example "Rogers"
     */
    lastName: string;
    /** The user image. */
    image: string;
}

export interface Invited {
    /** Who invited the user. */
    by: InvitedBy;
    /** The ISO 8601 date string of when the user was invited. */
    at: string;
}

export interface Joined {
    /** The ISO 8601 date string of when the user joined the company. */
    at: string;
}

export interface License {
    /** The ISO 8601 date string of when the license is valid from. */
    validFrom: string;
    /** The ISO 8601 date string of when the license expires. Null if the license does not expire */
    validTo: string | null;
}

export interface ViewerCapabilities {
    /** Whether the requesting user may edit the member's profile, photo or phone number. */
    canEditProfile: CapabilityFlag;
    /** Whether the requesting user may change the member's licence. */
    canManageLicences: CapabilityFlag;
    /** Whether the requesting user may change the member's company role. */
    canManageRoles: CapabilityFlag;
    /** Whether the requesting user may remove the member from the company. */
    canRemove: CapabilityFlag;
    /** Whether the requesting user may resend the member's invitation. */
    canResendInvite: CapabilityFlag;
    /** Whether the requesting user may see the member's app devices. Stricter than seeing the member: a plain shared-team member can read the member but not their devices. */
    canViewAppDevices: CapabilityFlag;
}

export interface CompanyUser {
    /**
     * The company user id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The company id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    companyId: string;
    /**
     * The user email.
     * @example "james@safepointapp.com"
     */
    email: string;
    /** The user image. */
    image: string;
    /**
     * The users id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    userId: string | null;
    /**
     * The users first name.
     * @example "James"
     */
    firstName: string | null;
    /**
     * The users last name.
     * @example "Rogers"
     */
    lastName: string | null;
    /**
     * The users phone number.
     * @example "+447808013499"
     */
    phone: string | null;
    /**
     * The users second phone number.
     * @example "+447808013500"
     */
    phone2: string | null;
    /** The users medical information. Omitted when the requesting users only access is unprivileged shared team membership. */
    medical?: UserMedical;
    /** The users next of kin. Omitted when the requesting users only access is unprivileged shared team membership. */
    contacts?: Contact[];
    /** The users description. Omitted when the requesting users only access is unprivileged shared team membership. */
    description?: UserDescription;
    /**
     * The users language (IETF language tag).
     * @example "en-gb"
     */
    language: string;
    /** The users notification settings. */
    notifications: UserNotificationsSettings;
    /** The users personal notification preferences. Null values mean the team setting applies. */
    guardianNotifications: UserGuardianNotifications;
    /**
     * The users role
     * @example "admin"
     */
    role: 'owner' | 'admin' | 'billing' | 'member';
    /** The users teams. */
    teams: TeamUser[];
    /** The user who invited this user. */
    invited: Invited | null;
    /** Whether the user has declined the invite. */
    hasDeclinedInvite: boolean;
    /** Whether the user has declined the invite. */
    joined: Joined | null;
    /** The users license. */
    license: License | null;
    /**
     * The users timezone.
     * @example "Europe/London"
     */
    timezone: string;
    /** Whether to automatically detect the users timezone. */
    timezoneAutoDetect: boolean;
    /** Whether the user uses 24-hour clock format. */
    use24HourClock: boolean;
    /**
     * The device power mode.
     * @example "NORMAL"
     */
    powerMode: 'NORMAL' | 'LOW';
    /** Whether the device should capture in-depth background-location telemetry for debugging. */
    debugMode: boolean;
    /** What the requesting user may do to this member. */
    capabilities: ViewerCapabilities;
    /**
     * How much of the member the requesting user sees. 'limited' — a plain member of a team they share — has the medical, contacts and description fields withheld; 'full' includes them.
     * @example "full"
     */
    access: 'full' | 'limited';
}

export interface CreateCompanyResponseData {
    /** The company. */
    company: Company;
    /** The team. */
    team: Team;
    /** The company users. */
    users: CompanyUser[];
}

export interface CreateCompanyResponse {
    data: CreateCompanyResponseData;
}

export interface GetCompaniesResponseData {
    /** The companies. */
    companies: Company[];
    /** The authenticated user's own company user in each of the companies above, one per company. */
    myUsers: CompanyUser[];
}

export interface GetCompaniesResponse {
    data: GetCompaniesResponseData;
}

export interface CompanyResponseData {
    /** The company */
    company: Company;
}

export interface CompanyResponse {
    data: CompanyResponseData;
}

export interface ForbiddenUnauthorisedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "UNAUTHORISED" */
    message: 'UNAUTHORISED';
}

export interface UpdateCompanyRequest {
    /**
     * The company name.
     * @example "Acme Inc."
     */
    companyName: string;
}

export interface FileRequiredErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "File is required" */
    message: 'File is required';
    /** @example "Bad Request" */
    error: 'Bad Request';
}

export interface CannotProcessFileErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_PROCESS_FILE" */
    message: 'CANNOT_PROCESS_FILE';
}

export interface SmsAlreadyEnabledErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "SMS_ALREADY_ENABLED" */
    message: 'SMS_ALREADY_ENABLED';
}

export interface NoSmsPaymentMethodErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "NO_SMS_PAYMENT_METHOD" */
    message: 'NO_SMS_PAYMENT_METHOD';
}

export interface SmsAlreadyDisabledErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "SMS_ALREADY_DISABLED" */
    message: 'SMS_ALREADY_DISABLED';
}

export interface SmsUsageResponseData {
    /** The used SMS credits for this billing period */
    creditsUsed: number;
}

export interface SmsUsageResponse {
    data: SmsUsageResponseData;
}

export interface AlreadySubscribedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "ALREADY_SUBSCRIBED" */
    message: 'ALREADY_SUBSCRIBED';
}

export interface CreateStripeCheckoutRequest {
    /** The stripe price ID */
    priceId: string;
    /**
     * The currency code (e.g., GBP, EUR, USD)
     * @example "GBP"
     */
    currency: string;
    /** The url for stripe to redirect to after a successful payment */
    successUrl: string;
    /** The url to redirect to after a cancelling */
    cancelUrl: string;
}

export interface StripeRedirectResponseData {
    /** The stripe redirect url */
    url: string;
}

export interface StripeRedirectResponse {
    data: StripeRedirectResponseData;
}

export interface CreateStripePortalRequest {
    /** The url for stripe to return to when the portal session is complete */
    returnUrl: string;
}

export interface AppSubscriptionUsage {
    /** The seat allowance from the app subscription */
    total: number;
    /** The number of licensed, non-deleted users in the company */
    used: number;
    /** The remaining seats (total - used), never negative */
    available: number;
}

export interface LwdFeatureSeats {
    /** The feature's seat allowance from the LWD subscription */
    total: number;
    /** The number of devices company-wide for which the feature is effectively enabled */
    used: number;
    /** The remaining seats (total - used), never negative */
    available: number;
}

export interface LwdSubscriptionUsage {
    /** Fall-alert seat counts */
    fall: LwdFeatureSeats;
    /** Tilt-alert seat counts */
    tilt: LwdFeatureSeats;
    /** Geofence seat counts */
    geofence: LwdFeatureSeats;
}

export interface SubscriptionUsageResponseData {
    /** The app subscription usage, or null when the company has no app subscription */
    app: AppSubscriptionUsage | null;
    /** The LWD feature seat counts (total/used/available), or null when the company has no LWD subscription */
    lwd: LwdSubscriptionUsage | null;
}

export interface SubscriptionUsageResponse {
    data: SubscriptionUsageResponseData;
}

export interface ForbiddenErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "Forbidden" */
    message: 'Forbidden';
}

export interface BeaconAlreadyExistsErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "BEACON_ALREADY_EXISTS" */
    message: 'BEACON_ALREADY_EXISTS';
}

export interface BeaconLocation {
    /**
     * The latitude.
     * @example 0
     */
    lat: number;
    /**
     * The longitude.
     * @example 0
     */
    lng: number;
}

export interface CreateBeaconRequest {
    /**
     * The beacon name.
     * @example "Room 102"
     */
    name: string;
    /**
     * The beacon tags.
     * @example ["Building A","Floor 1"]
     */
    tags: string[];
    /** The mac address. */
    mac: string;
    /** The company id. */
    companyId: string;
    /** The beacon location. */
    location?: BeaconLocation | null;
}

export interface BeaconBattery {
    /**
     * The battery level.
     * @example 100
     */
    level: number;
    /** The time the battery level was updated. ISO 8601 format. */
    updatedAt: string;
}

export interface Beacon {
    /**
     * The beacon id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The name of the beacon.
     * @example "Room A"
     */
    name: string;
    /**
     * Tags.
     * @example ["Building A","Floor 1"]
     */
    tags: string[];
    /**
     * The MAC address of the beacon.
     * @example "000a959d6816"
     */
    mac: string;
    /** The location position. */
    location: BeaconLocation | null;
    /** The battery level. */
    battery: BeaconBattery | null;
    /** The time the beacon was added. ISO 8601 format. */
    createdAt: string;
}

export interface GetBeaconResponseData {
    /** The beacon. */
    beacon: Beacon;
}

export interface GetBeaconResponse {
    data: GetBeaconResponseData;
}

export interface Beacons {
    /** The beacon data. */
    data: Beacon[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 10
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetBeaconsResponseData {
    /** The beacons. */
    beacons: Beacons;
}

export interface GetBeaconsResponse {
    data: GetBeaconsResponseData;
}

export interface BeaconNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "BEACON_NOT_FOUND" */
    message: 'BEACON_NOT_FOUND';
}

export interface UpdateBeaconRequest {
    /**
     * The beacon name.
     * @example "Room 102"
     */
    name?: string;
    /**
     * The beacon tags.
     * @example ["Building A","Floor 1"]
     */
    tags?: string[];
    /** The beacon location. */
    location?: BeaconLocation | null;
}

export interface DeviceNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "DEVICE_NOT_FOUND" */
    message: 'DEVICE_NOT_FOUND';
}

export interface InvalidUserErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "INVALID_USER" */
    message: 'INVALID_USER';
}

export interface BulkAssignDeviceTeamRequest {
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids to assign (1-100, unique).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
    /**
     * The team id to assign the devices to. The team must belong to the same company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    teamId: string;
    /**
     * The company user id to assign the devices to. Must belong to the same company and be a member of the team. When omitted or null, the devices are left unassigned.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyUserId?: string | null;
}

export interface DeviceTeam {
    /**
     * The team id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    teamId: string;
    /**
     * The team name.
     * @example "James"
     */
    name: string | null;
    /** The team image. */
    image: string | null;
}

export interface DeviceUser {
    /**
     * The company user id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    companyUserId: string;
    /**
     * The users id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    userId: string | null;
    /**
     * The users first name.
     * @example "James"
     */
    firstName: string | null;
    /**
     * The users last name.
     * @example "Rogers"
     */
    lastName: string | null;
    /** The users profile picture. */
    image: string | null;
    /** The users email. */
    email: string;
    /** Whether the user is invited or has joined the company. */
    joined: boolean;
}

export interface DeviceLocation {
    /**
     * The latitude.
     * @example 0
     */
    lat: number;
    /**
     * The longitude.
     * @example 0
     */
    lng: number;
    /**
     * The altitude.
     * @example 0
     */
    alt?: number;
    /**
     * The accuracy.
     * @example 0
     */
    acc?: number;
    /**
     * The speed.
     * @example 0
     */
    speed?: number;
    /**
     * The location timestamp. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    ts: string;
}

export interface DeviceBattery {
    /**
     * The battery level.
     * @example 100
     */
    level: number;
    /** Whether the device is charging or not. */
    isCharging: boolean;
    /** The time the battery level was updated. ISO 8601 format. */
    timestamp: string;
}

export interface BeaconSnapshot {
    /**
     * The name of the beacon.
     * @example "Room A"
     */
    name: string;
    /**
     * Tags.
     * @example ["Building A","Floor 1"]
     */
    tags: string[];
    /**
     * The MAC address of the beacon.
     * @example "000a959d6816"
     */
    mac: string;
    /** The location position. */
    location: BeaconLocation | null;
    /** The estimated distance between the device and beacon in meters. */
    distanceMeters: number;
}

export interface DeviceFeatures {
    /** If fall alerts are enabled. */
    fall: boolean;
    /** If tilt alerts are enabled. */
    tilt: boolean;
    /** If geofence alerts are enabled. */
    geofence: boolean;
    /** If wifi is enabled. */
    wifi: boolean;
    /** The wifi SSIDs. */
    wifiSSIDs?: string[];
}

export interface DeviceConfigWifi {
    /** Whether this WiFi slot is enabled */
    enabled: boolean;
    /** The WiFi SSID, or null when the slot is disabled */
    ssid: string | null;
    /** The WiFi password (masked), or null when the slot is disabled. Company owners/admins and team admins see it semi-masked (first two characters, e.g. "pa*****"); everyone else sees it fully masked. */
    password: string | null;
    /** Whether the device is connected to this WiFi */
    connected: boolean;
    /** When the device last reported this config */
    updatedAt: string;
}

export interface GeoAlertPoint {
    /**
     * The point latitude
     * @example 51.5074
     */
    latitude: number;
    /**
     * The point longitude
     * @example -0.1278
     */
    longitude: number;
}

export interface DeviceConfigGeoAlert {
    /** Whether this geofence slot is enabled */
    enabled: boolean;
    /** Whether the alert fires on entering or exiting */
    direction: 'in' | 'out';
    /** The geofence shape, or null when the slot has no shape */
    shape: 'circle' | 'polygon' | null;
    /** The circle radius in metres, or null for a polygon or a slot with no shape */
    radius: number | null;
    /** The geofence points (1 centre for a circle; 3-15 vertices for a polygon), or null when the slot has no shape */
    points: GeoAlertPoint[] | null;
    /** When the device last reported this config */
    updatedAt: string;
}

export interface DeviceConfigFallAlert {
    /** Whether fall alert is enabled */
    enabled: boolean;
    /** The fall alert sensitivity */
    sensitivity: number;
    /** When the device last reported this config */
    updatedAt: string;
}

export interface DeviceConfigTiltAlert {
    /** Whether tilt alert is enabled */
    enabled: boolean;
    /** The tilt alert angle */
    angle: number;
    /** The tilt alert time threshold */
    timeThreshold: number;
    /** When the device last reported this config */
    updatedAt: string;
}

export interface DeviceConfig {
    /** WiFi configurations keyed by slot index */
    wifi: Record<string, DeviceConfigWifi>;
    /** Fall alert configuration */
    fallAlert: DeviceConfigFallAlert | null;
    /** Tilt alert configuration */
    tiltAlert: DeviceConfigTiltAlert | null;
    /** Geo alert configurations keyed by slot index (geoAlertIndex) */
    geoAlert: Record<string, DeviceConfigGeoAlert>;
}

export interface DeviceCommandDataModel {
    wifiSsid?: string | null;
    /** The WiFi password (masked). Semi-masked for company owners/admins and team admins; fully masked for everyone else. */
    wifiPassword?: string | null;
    wifiIndex?: number;
    wifiEnabled?: boolean;
    tiltAlertEnabled?: boolean;
    tiltAlertAngle?: number;
    tiltAlertTimeThreshold?: number;
    fallAlertEnabled?: boolean;
    fallAlertSensitivity?: number;
    geoAlertIndex?: number;
    geoAlertEnabled?: boolean;
    geoAlertDirection?: string;
    geoAlertShape?: string | null;
    geoAlertRadius?: number | null;
    geoAlertPoints?: GeoAlertPoint[] | null;
}

export interface DeviceCommand {
    /**
     * The id of the source command document
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    commandId: string;
    /** pending while in flight, then success or error */
    status: 'pending' | 'error' | 'success';
    /** The command type */
    type:
        | 'set_wifi'
        | 'set_sms_password'
        | 'set_tilt_alert'
        | 'set_fall_alert'
        | 'set_geo_alert'
        | 'read_config'
        | 'reboot'
        | 'power_off';
    /** The command payload */
    data: DeviceCommandDataModel;
    /** The reason the command failed, if any */
    failureReason: string | null;
    /** When the command was requested */
    createdAt: string;
    /** When the command status last changed */
    updatedAt: string;
}

export interface Device {
    /**
     * The standalone device id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /** The name of the device */
    name: string;
    /** The phone number of the device */
    phone: string | null;
    /** The image of the device */
    image: string;
    /** The id of the company the device belongs to */
    companyId: string | null;
    /** The team that this device triggers alerts for */
    team: DeviceTeam | null;
    /** The user that this device triggers alerts for */
    user: DeviceUser | null;
    /** The location position. Only returned to the device owner, company owners/admins, and team admins/guardians. */
    location?: DeviceLocation | null;
    /** The battery level. */
    battery?: DeviceBattery | null;
    /** The detected beacons. Only returned to the device owner, company owners/admins, and team admins/guardians. */
    beaconSnapshot?: BeaconSnapshot[];
    /** The time the detected beacons where updated. ISO 8601 format. Only returned to the device owner, company owners/admins, and team admins/guardians. */
    beaconsUpdatedAt?: string | null;
    /** The enabled features on this device. */
    features: DeviceFeatures;
    /** The device configuration (reported state). */
    config?: DeviceConfig;
    /** Denormalised copy of the device commands (config changes + actions), each with a pending/success/error status. */
    commands?: DeviceCommand[];
}

export interface BulkDevicesResponseData {
    /** The updated devices. */
    devices: Device[];
}

export interface BulkDevicesResponse {
    data: BulkDevicesResponseData;
}

export interface Devices {
    /** The device data. */
    data: Device[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 10
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetDevicesResponseData {
    /** The devices. */
    devices: Devices;
}

export interface GetDevicesResponse {
    data: GetDevicesResponseData;
}

export interface DeviceNoPhoneErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "DEVICE_NO_PHONE" */
    message: 'DEVICE_NO_PHONE';
}

export interface DeviceNoSmsPasswordErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "DEVICE_NO_SMS_PASSWORD" */
    message: 'DEVICE_NO_SMS_PASSWORD';
}

export interface DeviceTestResponseData {
    /** The status ID to poll for test status. */
    statusId: string;
}

export interface DeviceTestResponse {
    data: DeviceTestResponseData;
}

export interface DeviceTestCallStatusData {
    /** The Twilio call status. */
    status:
        | 'queued'
        | 'ringing'
        | 'in-progress'
        | 'completed'
        | 'busy'
        | 'no-answer'
        | 'failed'
        | 'canceled'
        | null;
}

export interface DeviceTestSmsStatusData {
    /** The unified SMS status. */
    status:
        | 'queued'
        | 'sending'
        | 'sent'
        | 'delivered'
        | 'undelivered'
        | 'failed'
        | 'receiving'
        | 'received'
        | 'accepted'
        | 'scheduled'
        | 'read'
        | 'partially_delivered'
        | 'canceled'
        | 'response_pending'
        | 'response_received'
        | 'response_timed_out'
        | null;
}

export interface DeviceTestStatusResponseData {
    call: DeviceTestCallStatusData;
    sms: DeviceTestSmsStatusData;
}

export interface DeviceTestStatusResponse {
    data: DeviceTestStatusResponseData;
}

export interface GetDeviceResponseData {
    /** The device. */
    device: Device;
}

export interface GetDeviceResponse {
    data: GetDeviceResponseData;
}

export interface UpdateDeviceRequest {
    /**
     * The device name.
     * @example "Lone Worker 1"
     */
    name?: string;
    /** The team id. */
    teamId: string;
    /** The company user id. */
    companyUserId: string | null;
}

export interface AssignDeviceRequest {
    /** The team id. */
    teamId: string;
}

export interface DeviceAlreadyActivatedErrorResponse {
    /** @example 409 */
    statusCode: 409;
    /** @example "DEVICE_ALREADY_ACTIVATED" */
    message: 'DEVICE_ALREADY_ACTIVATED';
}

export interface SimClosedErrorResponse {
    /** @example 409 */
    statusCode: 409;
    /** @example "SIM_CLOSED" */
    message: 'SIM_CLOSED';
}

export interface NoMoreLicensesErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "NO_MORE_LICENSES" */
    message: 'NO_MORE_LICENSES';
}

export interface DeviceNotSetupErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "DEVICE_NOT_SETUP" */
    message: 'DEVICE_NOT_SETUP';
}

export interface ActivateDeviceRequest {
    /** The company id to activate the device under. */
    companyId: string;
}

export interface BulkDeviceIdsRequest {
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids to apply the operation to (1-100, unique).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
}

export interface BulkUpdateDeviceConfigFallAlertRequest {
    /** Whether the fall alert should be enabled. */
    enabled: boolean;
    /**
     * The fall alert sensitivity (1-9). Defaults to 4 when omitted (e.g. when disabling).
     * @min 1
     * @max 9
     * @default 4
     */
    sensitivity?: number;
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids to apply the change to (1-100, unique, all in the company).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
}

export interface BulkUpdateDeviceConfigTiltAlertRequest {
    /** Whether the tilt alert should be enabled. */
    enabled: boolean;
    /**
     * The tilt alert angle threshold (30-90). Defaults to 45 when omitted (e.g. when disabling).
     * @min 30
     * @max 90
     * @default 45
     */
    angle?: number;
    /**
     * The tilt alert time threshold in seconds (10-180). Defaults to 180 when omitted (e.g. when disabling).
     * @min 10
     * @max 180
     * @default 180
     */
    timeThreshold?: number;
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids to apply the change to (1-100, unique, all in the company).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
}

export interface BulkUpdateDeviceConfigWifiRequest {
    /** Whether this WiFi slot should be enabled. */
    enabled: boolean;
    /**
     * The WiFi SSID (non-empty, max 32 chars) or null. Omit to default to null.
     * @maxLength 32
     */
    ssid?: string | null;
    /**
     * The WiFi password (non-empty, max 32 chars) or null for an open network. Omit to default to null.
     * @maxLength 32
     */
    password?: string | null;
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids to apply the change to (1-100, unique, all in the company).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
    /**
     * The WiFi slot index (0-4) to set on every device.
     * @min 0
     * @max 4
     * @example 0
     */
    slot: number;
}

export interface GeoAlertPointRequest {
    /**
     * The point latitude (-90 to 90).
     * @example 51.5074
     */
    latitude: number;
    /**
     * The point longitude (-180 to 180).
     * @example -0.1278
     */
    longitude: number;
}

export interface BulkUpdateDeviceConfigGeoAlertRequest {
    /** Whether this geofence slot should be enabled. */
    enabled: boolean;
    /** Whether to alert on entering or exiting the geofence. Required when enabling; defaults to `in` if omitted while disabling. */
    direction?: 'in' | 'out';
    /** The geofence shape. Required when enabling; may be omitted or null to clear the shape while disabling. */
    shape?: 'circle' | 'polygon' | null;
    /**
     * The circle radius in metres (0-65535). Required for a circle; null for a polygon or a cleared slot.
     * @min 0
     * @max 65535
     */
    radius?: object | null;
    /** The geofence points. A circle has exactly 1 centre point; a polygon has 3-15 vertices. Required when enabling; may be omitted or null to clear while disabling. */
    points?: GeoAlertPointRequest[] | null;
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids to apply the change to (1-100, unique, all in the company).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
    /**
     * The geo alert slot index (0-3) to set on every device, used as the geoAlertIndex.
     * @min 0
     * @max 3
     * @example 0
     */
    slot: number;
}

export interface BulkCancelDeviceConfigWifiRequest {
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids whose pending change should be cancelled (1-100, unique, all in the company).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
    /**
     * The WiFi slot index (0-4).
     * @min 0
     * @max 4
     * @example 0
     */
    slot: number;
}

export interface BulkCancelDeviceConfigGeoAlertRequest {
    /**
     * The company the devices belong to. All devices must be in this company.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    companyId: string;
    /**
     * The device ids whose pending change should be cancelled (1-100, unique, all in the company).
     * @example ["6315a5ed4c8edd17c30b2dc9"]
     */
    deviceIds: string[];
    /**
     * The geo alert slot index (0-3), used as the geoAlertIndex.
     * @min 0
     * @max 3
     * @example 0
     */
    slot: number;
}

export interface UpdateDeviceConfigFallAlertRequest {
    /** Whether the fall alert should be enabled. */
    enabled: boolean;
    /**
     * The fall alert sensitivity (1-9). Defaults to 4 when omitted (e.g. when disabling).
     * @min 1
     * @max 9
     * @default 4
     */
    sensitivity?: number;
}

export interface UpdateDeviceConfigTiltAlertRequest {
    /** Whether the tilt alert should be enabled. */
    enabled: boolean;
    /**
     * The tilt alert angle threshold (30-90). Defaults to 45 when omitted (e.g. when disabling).
     * @min 30
     * @max 90
     * @default 45
     */
    angle?: number;
    /**
     * The tilt alert time threshold in seconds (10-180). Defaults to 180 when omitted (e.g. when disabling).
     * @min 10
     * @max 180
     * @default 180
     */
    timeThreshold?: number;
}

export interface UpdateDeviceConfigWifiRequest {
    /** Whether this WiFi slot should be enabled. */
    enabled: boolean;
    /**
     * The WiFi SSID (non-empty, max 32 chars) or null. Omit to default to null.
     * @maxLength 32
     */
    ssid?: string | null;
    /**
     * The WiFi password (non-empty, max 32 chars) or null for an open network. Omit to default to null.
     * @maxLength 32
     */
    password?: string | null;
}

export interface UpdateDeviceConfigGeoAlertRequest {
    /** Whether this geofence slot should be enabled. */
    enabled: boolean;
    /** Whether to alert on entering or exiting the geofence. Required when enabling; defaults to `in` if omitted while disabling. */
    direction?: 'in' | 'out';
    /** The geofence shape. Required when enabling; may be omitted or null to clear the shape while disabling. */
    shape?: 'circle' | 'polygon' | null;
    /**
     * The circle radius in metres (0-65535). Required for a circle; null for a polygon or a cleared slot.
     * @min 0
     * @max 65535
     */
    radius?: object | null;
    /** The geofence points. A circle has exactly 1 centre point; a polygon has 3-15 vertices. Required when enabling; may be omitted or null to clear while disabling. */
    points?: GeoAlertPointRequest[] | null;
}

export interface FilterOption {
    /**
     * The id of the team, company user or device.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The display name of the option.
     * @example "Northern Response Team"
     */
    name: string;
    /** The image URL of the option. */
    image: string | null;
}

export interface FilterOptions {
    /** The filter option data. */
    data: FilterOption[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 10
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetFilterOptionsResponseData {
    /** The filter options. */
    options: FilterOptions;
}

export interface GetFilterOptionsResponse {
    data: GetFilterOptionsResponseData;
}

export interface DeviceFilterOption {
    /**
     * The id of the team, company user or device.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The display name of the option.
     * @example "Northern Response Team"
     */
    name: string;
    /** The image URL of the option. */
    image: string | null;
    /** The company user the device is assigned to (the id is the company user id), or null when the device is unassigned. */
    user: FilterOption | null;
}

export interface DeviceFilterOptions {
    /** The filter option data. */
    data: DeviceFilterOption[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 10
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetDeviceFilterOptionsResponseData {
    /** The filter options. */
    options: DeviceFilterOptions;
}

export interface GetDeviceFilterOptionsResponse {
    data: GetDeviceFilterOptionsResponseData;
}

export interface CountryData {
    /**
     * ISO 3166-1 alpha-2 country code
     * @example "GB"
     */
    isoCode?: string;
    /**
     * Country name in English
     * @example "United Kingdom"
     */
    name?: string;
}

export interface SubdivisionData {
    /**
     * ISO 3166-2 subdivision code
     * @example "ENG"
     */
    isoCode?: string;
    /**
     * Subdivision/region name in English
     * @example "England"
     */
    name?: string;
}

export interface CityData {
    /**
     * City name in English
     * @example "London"
     */
    name?: string;
}

export interface GetLocationResponseData {
    /** Country information */
    country?: CountryData | null;
    /** Region/subdivision information (e.g., state, province) */
    subdivision?: SubdivisionData | null;
    /** City information */
    city?: CityData | null;
    /**
     * IANA timezone identifier
     * @example "Europe/London"
     */
    timezone?: string | null;
}

export interface GetLocationResponse {
    data: GetLocationResponseData;
}

export interface Invite {
    /**
     * The invite id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The invited users email.
     * @example "john@example.com"
     */
    email: string;
    /**
     * The company id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    companyId: string;
    /**
     * The company name.
     * @example "ABC Company"
     */
    companyName: string;
    /** The company profile picture. */
    companyImage: string;
    /** The date the user was invited in ISO format. */
    invitedAt: string;
}

export interface GetInvitesResponseData {
    /** The invites. */
    invites: Invite[];
}

export interface GetInvitesResponse {
    data: GetInvitesResponseData;
}

export interface InviteNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "INVITE_NOT_FOUND" */
    message: 'INVITE_NOT_FOUND';
}

export interface AcceptInviteResponseData {
    /** The company. */
    company: Company;
}

export interface AcceptInviteResponse {
    data: AcceptInviteResponseData;
}

export interface GetMeResponseData {
    /** The user object. */
    user: User;
}

export interface GetMeResponse {
    data: GetMeResponseData;
}

export interface IncorrectPasswordErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "INCORRECT_PASSWORD" */
    message: 'INCORRECT_PASSWORD';
}

export interface UpdatePasswordRequest {
    /** The users old password. */
    oldPassword: string;
    /** The users new password. */
    newPassword: string;
}

export interface UpdatePinRequest {
    /** The users password. */
    password: string;
    /**
     * The users pin — a 4-digit number.
     * @example "1234"
     */
    pin: string;
}

export interface EmailAlreadyVerifiedErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "EMAIL_ALREADY_VERIFIED" */
    message: 'EMAIL_ALREADY_VERIFIED';
}

export interface EmailAlreadyInUseErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "EMAIL_ALREADY_IN_USE" */
    message: 'EMAIL_ALREADY_IN_USE';
}

export interface UpdateEmailRequest {
    /** The users password. */
    password: string;
    /** The users new email. */
    newEmail: string;
}

export interface UpsertAppDeviceRequest {
    /** Unique device identifier (UUID or vendor-specific ID) */
    deviceId: string;
    /** Human-readable device name */
    deviceName: string;
    /**
     * Platform name (e.g. "ios" or "android")
     * @example "android"
     */
    platform: string;
    /**
     * Operating system version
     * @example "14"
     */
    osVersion: string;
    /**
     * Device manufacturer name
     * @example "Google"
     */
    manufacturer: string;
    /**
     * Device model name
     * @example "Pixel 8 Pro"
     */
    model: string;
    /**
     * App version string
     * @example "2.4.1"
     */
    appVersion: string;
    /**
     * App build number (internal version code)
     * @example "147"
     */
    appBuild: string;
    /**
     * The Firebase Cloud Messaging registration token this install currently holds. Omit it when the app has no token to report — the stored token is then left as it is. Send null to clear it, e.g. when Firebase invalidates the token.
     * @example "fMEXAMPLE_TOKEN:APA91bH..."
     */
    fcmToken?: string | null;
    /**
     * Device-level or app-specific settings
     * @example {"bypassDnd":true}
     */
    settings?: object;
}

export interface NotificationTeam {
    /**
     * The team id.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    id: string;
    /**
     * The team name, or `Unknown` when the team no longer exists.
     * @example "North Field"
     */
    name: string;
    /**
     * The team image, or an empty string when the team no longer exists.
     * @example "https://example.com/team.jpg"
     */
    image: string;
}

export interface Notification {
    /**
     * The notification id.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    id: string;
    /**
     * The notification title.
     * @example "James started a task"
     */
    title: string;
    /**
     * The notification body.
     * @example null
     */
    content: string | null;
    /**
     * The avatar to show: the triggering user, the device icon when a lone worker device triggered it, or a placeholder.
     * @example "https://example.com/user.jpg"
     */
    image: string;
    /**
     * A deep link to the subject of the notification.
     * @example "tasks#6315a5ed4c8edd17c30b2dc9"
     */
    link: string | null;
    /** The team the notification was raised for. */
    team: NotificationTeam;
    /**
     * The task the notification was raised for.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    taskId: string;
    /**
     * When the notification was read, or null when unread. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    readAt: string | null;
    /**
     * When the notification was created. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    timestamp: string;
}

export interface Notifications {
    /** The notification data. */
    data: Notification[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 25
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetNotificationsResponseData {
    /**
     * The user's total unread notification count. Not affected by the `status` filter.
     * @example 7
     */
    unreadCount: number;
    /** The notifications. */
    notifications: Notifications;
}

export interface GetNotificationsResponse {
    data: GetNotificationsResponseData;
}

export interface MarkNotificationsReadRequest {
    /**
     * The task whose notifications should be marked read. Every unread notification the caller holds for the task is marked.
     * @example "6315a5ed4c8edd17c30b2dc9"
     */
    taskId: string;
}

export interface MarkNotificationsReadResponseData {
    /**
     * The user's remaining unread notification count.
     * @example 5
     */
    unreadCount: number;
    /**
     * When the notifications were marked read. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    readAt: string;
}

export interface MarkNotificationsReadResponse {
    data: MarkNotificationsReadResponseData;
}

export interface CurrencyPrice {
    /**
     * The currency code (e.g., GBP, EUR, USD)
     * @example "GBP"
     */
    currency: string;
    /**
     * The price in the smallest currency unit (e.g., cents/pence)
     * @example 1499
     */
    amount: number;
}

export interface SubscriptionPrice {
    /**
     * The unique identifier for this price configuration
     * @example "STANDARD_MONTHLY"
     */
    priceKey: string;
    /** The plan type */
    planType: 'STANDARD' | 'GUARDIAN_PLUS';
    /** The billing interval */
    interval: 'month' | 'year';
    /**
     * The Stripe price ID
     * @example "price_1234567890"
     */
    stripePriceId: string;
    /**
     * Whether this plan is available for purchase
     * @example true
     */
    isAvailable: boolean;
    /**
     * URL to redirect users when plan is unavailable (e.g., coming soon signup page)
     * @example "https://example.com/coming-soon"
     */
    unavailableUrl?: string;
    /** Available prices in different currencies */
    currencyPrices: CurrencyPrice[];
}

export interface GetPricesResponseData {
    /** The subscription prices */
    prices: SubscriptionPrice[];
    /**
     * Recommended default currency based on user location
     * @example "GBP"
     */
    defaultCurrency: string;
}

export interface GetPricesResponse {
    data: GetPricesResponseData;
}

export interface TaskUser {
    /**
     * The users id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The users first name.
     * @example "James"
     */
    firstName: string | null;
    /**
     * The users last name.
     * @example "Rogers"
     */
    lastName: string | null;
    /** The users profile picture. */
    image: string | null;
}

export interface TaskCompanyUser {
    /**
     * The company user id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The users first name.
     * @example "James"
     */
    firstName: string | null;
    /**
     * The users last name.
     * @example "Rogers"
     */
    lastName: string | null;
    /** The users profile picture. */
    image: string | null;
    /**
     * The users email.
     * @example "james@safepointapp.com"
     */
    email: string | null;
}

export interface TaskDevice {
    /**
     * The device id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The device name.
     * @example "LWD 1"
     */
    name: string | null;
    /** The device image. */
    image: string | null;
}

export interface TaskDisplayInfo {
    /**
     * The display name.
     * @example "James Rogers OR LWD 1 OR Unknown"
     */
    name: string;
    /** The display image. */
    image: string;
    /** The sub display text. */
    subText: string | null;
    /** The sub display image. */
    subImage: string | null;
}

export interface TaskTeam {
    /**
     * The team id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The team name. Null if deleted.
     * @example "Night Shift"
     */
    name: string | null;
    /** The teams profile picture. Null if deleted. */
    image: string | null;
    /** Whether the team is deleted. */
    deleted: boolean;
}

export interface TaskAlertAction {
    /** The user */
    user: TaskUser;
    /** The time the action was taken. ISO 8601 format. */
    time: string;
    /** Whether the action was taken by the ARC. */
    isArc: boolean;
}

export interface TaskAlertResolveAction {
    /** The user */
    user: TaskUser;
    /** The time the action was taken. ISO 8601 format. */
    time: string;
    /** Whether the action was taken by the ARC. */
    isArc: boolean;
    /** Whether the alert was a false alarm. Null means undecided. */
    isFalseAlarm: boolean | null;
    /** The reasons for the alert. */
    reasons: (
        | 'CONTACT_WITH_ELECTRICITY'
        | 'CONTACT_WITH_MACHINERY'
        | 'DROWNED_OR_ASPHYXIATED'
        | 'EXPOSED_TO_EXPLOSION'
        | 'EXPOSED_TO_FIRE'
        | 'EXPOSED_TO_HARMFUL_SUBSTANCE'
        | 'FALL_FROM_HEIGHT'
        | 'INJURED_BY_ANIMAL'
        | 'LIFTING_AND_HANDLING'
        | 'PHYSICAL_ASSAULT_OR_ACT_OF_VIOLENCE'
        | 'SLIP_TRIP_FALL_SAME_HEIGHT'
        | 'STRUCK_AGAINST'
        | 'STRUCK_BY_MOVING_OBJECT'
        | 'STRUCK_BY_OBJECT'
        | 'TRAPPED_BY_SOMETHING_COLLAPSING'
        | 'OTHER'
    )[];
    /** The injury sustained. */
    injury: 'NONE' | 'MINOR' | 'MAJOR' | 'UNKNOWN' | null;
    /** The emergency services called. */
    emergencyServices: ('AMBULANCE' | 'FIRE' | 'POLICE')[];
    /** The note added. */
    note: string | null;
}

export interface TaskAlert {
    /**
     * The alert id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /** The type of alert. */
    type:
        | 'EXPIRED_ALERT'
        | 'MANUAL_ALERT'
        | 'ACTIVE_MANUAL_ALERT'
        | 'INACTIVE_MANUAL_ALERT'
        | 'DURESS_ALERT'
        | 'CHECK_IN_ALERT'
        | 'FALL_MOTION_ALERT'
        | 'STILL_MOTION_ALERT'
        | 'GEOFENCE_ALERT'
        | 'TILT_ALERT';
    /** The alert acknowledged data. */
    acknowledged: TaskAlertAction | null;
    /** The alert assigned data. */
    assigned: TaskAlertAction | null;
    /** The alert resolved data. */
    resolved: TaskAlertResolveAction | null;
    /** The time the alert was created. ISO 8601 format */
    createdAt: string;
}

export interface TaskLocation {
    /**
     * The location latitude.
     * @example 0
     */
    lat: number;
    /**
     * The longitude.
     * @example 0
     */
    lng: number;
    /**
     * The altitude.
     * @example 0
     */
    alt?: number;
    /**
     * The accuracy.
     * @example 0
     */
    acc?: number;
    /**
     * The speed.
     * @example 0
     */
    speed?: number;
    /**
     * The What3Words address.
     * @example "index.home.raft"
     */
    w3w?: string;
    /**
     * The geo address.
     * @example "20 Kings Road"
     */
    fullGeo?: string;
    /**
     * The geo address.
     * @example "20 Kings Road"
     */
    shortGeo?: string;
    /**
     * The location timestamp. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    ts: string;
}

export interface TaskBattery {
    /**
     * The battery percentage, measured between 0-100.
     * @example 0
     */
    level?: number;
    /** Whether the battery is charging or not. */
    isCharging: boolean;
    /**
     * The location timestamp. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    ts: string;
}

export interface TaskSignal {
    /** The signal type. */
    type: '2G' | '3G' | '4G' | '5G' | 'WIFI' | 'UNKNOWN';
    /** The signal strength in decibels. */
    strength?: number;
    /**
     * The signal strength, measured in levels between 0-4.
     * @example 0
     */
    level?: number;
    /**
     * The location timestamp. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    ts: string;
}

export interface Task {
    /**
     * The task id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The title of the task.
     * @example "Client Visit"
     */
    title: string;
    /** The time the task started. ISO 8601 format. */
    startTime: string;
    /** The time the task is due. ISO 8601 format. */
    dueTime: string;
    /** The time the task ended. ISO 8601 format. */
    endTime: string | null;
    /** The time the task was completed. ISO 8601 format. */
    completeTime: string | null;
    /**
     * The duration of the task in mins.
     * @example 60
     */
    durationMins: number;
    /** The status of the task. */
    status:
        | 'ACTIVE'
        | 'COMPLETED'
        | 'EXPIRED_ALERT'
        | 'MANUAL_ALERT'
        | 'ACTIVE_MANUAL_ALERT'
        | 'INACTIVE_MANUAL_ALERT'
        | 'DURESS_ALERT'
        | 'CHECK_IN_ALERT'
        | 'FALL_MOTION_ALERT'
        | 'STILL_MOTION_ALERT'
        | 'GEOFENCE_ALERT'
        | 'TILT_ALERT';
    /** The simple status of the task. */
    simpleStatus: 'ACTIVE' | 'COMPLETED' | 'ALERTED';
    /** The user who created the task. */
    user: TaskUser | null;
    /** The company user the task belongs to. Null when the task has no user, or was created before the company user was recorded on the task. */
    companyUser: TaskCompanyUser | null;
    /** The device that created the task. */
    device: TaskDevice | null;
    /** The task display info. */
    displayInfo: TaskDisplayInfo;
    /** The company id of the task. */
    companyId: string;
    /** The team id of the task. */
    team: TaskTeam;
    /** The task alert. */
    alert: TaskAlert | null;
    /** Whether the task is ARC enabled. */
    isArcEnabled: boolean;
    /** Whether the task has been passed back by the ARC. */
    isArcPassedBack: boolean;
    /** Whether the task requires a pin. */
    pinRequired: boolean;
    /** The location of the task. */
    location: TaskLocation | null;
    /** The battery of the users device. */
    battery: TaskBattery | null;
    /** The signal of the users device. */
    signal: TaskSignal | null;
    /** The beacons in range of the device. */
    beaconSnapshot: BeaconSnapshot[];
    /** The time the beacons were last updated. ISO 8601 format. */
    beaconsUpdatedAt: string | null;
}

export interface Tasks {
    /** The task data. */
    data: Task[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 10
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetTasksResponseData {
    /** The tasks. */
    tasks: Tasks;
}

export interface GetTasksResponse {
    data: GetTasksResponseData;
}

export interface TaskNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "TASK_NOT_FOUND" */
    message: 'TASK_NOT_FOUND';
}

export interface GetTaskResponseData {
    /** The task. */
    task: Task;
}

export interface GetTaskResponse {
    data: GetTaskResponseData;
}

export interface TaskEventUser {
    /**
     * The users id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The users first name.
     * @example "James"
     */
    firstName: string | null;
    /**
     * The users last name.
     * @example "Rogers"
     */
    lastName: string | null;
    /** The users profile picture. */
    image: string | null;
}

export interface TaskEventDevice {
    /**
     * The device id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The device name.
     * @example "LWD 1"
     */
    name: string | null;
    /** The device image. */
    image: string | null;
}

export interface TaskEventDisplayInfo {
    /**
     * The display name.
     * @example "James Rogers OR LWD 1 OR Unknown"
     */
    name: string;
    /** The display image. */
    image: string;
    /** The sub display text. */
    subText: string | null;
    /** The sub display image. */
    subImage: string | null;
}

export interface TaskDetailAlert {
    /**
     * The alert id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    alertId: string;
}

export interface TaskDetailAcknowledge {
    /**
     * The alert id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    alertId: string;
}

export interface TaskDetailAssign {
    /**
     * The alert id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    alertId: string;
}

export interface TaskDetailResolve {
    /**
     * The alert id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    alertId: string;
    /** Whether the alert was a false alarm. Null means undecided. */
    isFalseAlarm: boolean | null;
    /** The reasons for the alert. */
    reasons: (
        | 'CONTACT_WITH_ELECTRICITY'
        | 'CONTACT_WITH_MACHINERY'
        | 'DROWNED_OR_ASPHYXIATED'
        | 'EXPOSED_TO_EXPLOSION'
        | 'EXPOSED_TO_FIRE'
        | 'EXPOSED_TO_HARMFUL_SUBSTANCE'
        | 'FALL_FROM_HEIGHT'
        | 'INJURED_BY_ANIMAL'
        | 'LIFTING_AND_HANDLING'
        | 'PHYSICAL_ASSAULT_OR_ACT_OF_VIOLENCE'
        | 'SLIP_TRIP_FALL_SAME_HEIGHT'
        | 'STRUCK_AGAINST'
        | 'STRUCK_BY_MOVING_OBJECT'
        | 'STRUCK_BY_OBJECT'
        | 'TRAPPED_BY_SOMETHING_COLLAPSING'
        | 'OTHER'
    )[];
    /** The injury received during the alert. */
    injury: 'NONE' | 'MINOR' | 'MAJOR' | 'UNKNOWN' | null;
    /** The emergency services contacted during the alert. */
    emergencyServices: (
        | 'CONTACT_WITH_ELECTRICITY'
        | 'CONTACT_WITH_MACHINERY'
        | 'DROWNED_OR_ASPHYXIATED'
        | 'EXPOSED_TO_EXPLOSION'
        | 'EXPOSED_TO_FIRE'
        | 'EXPOSED_TO_HARMFUL_SUBSTANCE'
        | 'FALL_FROM_HEIGHT'
        | 'INJURED_BY_ANIMAL'
        | 'LIFTING_AND_HANDLING'
        | 'PHYSICAL_ASSAULT_OR_ACT_OF_VIOLENCE'
        | 'SLIP_TRIP_FALL_SAME_HEIGHT'
        | 'STRUCK_AGAINST'
        | 'STRUCK_BY_MOVING_OBJECT'
        | 'STRUCK_BY_OBJECT'
        | 'TRAPPED_BY_SOMETHING_COLLAPSING'
        | 'OTHER'
    )[];
}

export interface TaskDetailPassback {
    /**
     * The alert id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    alertId: string;
    /** The reason for the passback. */
    reason: 'CUSTOMER_REQUESTED' | 'UNCONTACTABLE';
}

export interface TaskEvent {
    /**
     * The event id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /**
     * The task id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    taskId: string;
    /** The status of the task. */
    taskStatus:
        | 'ACTIVE'
        | 'COMPLETED'
        | 'EXPIRED_ALERT'
        | 'MANUAL_ALERT'
        | 'ACTIVE_MANUAL_ALERT'
        | 'INACTIVE_MANUAL_ALERT'
        | 'DURESS_ALERT'
        | 'CHECK_IN_ALERT'
        | 'FALL_MOTION_ALERT'
        | 'STILL_MOTION_ALERT'
        | 'GEOFENCE_ALERT'
        | 'TILT_ALERT';
    /** The user who created the task event. */
    user: TaskEventUser | null;
    /** The device that created the task event. */
    device: TaskEventDevice | null;
    /** The task event display info. */
    displayInfo: TaskEventDisplayInfo;
    /** The type of the event. */
    type:
        | 'CREATE'
        | 'EXTEND'
        | 'COMPLETE'
        | 'EXPIRED_ALERT'
        | 'MANUAL_ALERT'
        | 'ACTIVE_MANUAL_ALERT'
        | 'INACTIVE_MANUAL_ALERT'
        | 'DURESS_ALERT'
        | 'CHECK_IN_ALERT'
        | 'FALL_MOTION_ALERT'
        | 'STILL_MOTION_ALERT'
        | 'GEOFENCE_ALERT'
        | 'TILT_ALERT'
        | 'ALERT_CANCELLED'
        | 'ALERT_RESOLVED'
        | 'ALERT_ACKNOWLEDGED'
        | 'ALERT_ASSIGNED'
        | 'ALERT_UNASSIGNED'
        | 'ALERT_PASSBACK'
        | 'NOTE';
    /** The minutes extended if type is EXTEND. */
    additionalMinutes: number | null;
    /** The alert info if the type is ALERTED. */
    alerted: TaskDetailAlert | null;
    /** The acknowledged info if the type is ALERT_ACKNOWLEDGED. */
    acknowledged: TaskDetailAcknowledge | null;
    /** The assigned info if the type is ALERT_ASSIGNED. */
    assigned: TaskDetailAssign | null;
    /** The resolved info if the type is ALERT_RESOLVED. */
    resolved: TaskDetailResolve | null;
    /** The passback info if the type is ALERT_PASSBACK. */
    passback: TaskDetailPassback | null;
    /** A user provided note. */
    note: string | null;
    /** The location of the task. */
    location: TaskLocation | null;
    /** The device id. */
    deviceId: string | null;
    /** The beacons in range of the device. */
    beaconSnapshot: BeaconSnapshot[];
    /** The time the beacons were last updated. ISO 8601 format. */
    beaconsUpdatedAt: string | null;
    /** Whether the event was created by the ARC team. */
    isArc: boolean | null;
    /** The time the event was created. ISO 8601 format. */
    createdAt: string;
}

export interface TaskEvents {
    /** The task event data. */
    data: TaskEvent[];
}

export interface GetTaskEventsResponseData {
    /** The task events. */
    events: TaskEvents;
}

export interface GetTaskEventsResponse {
    data: GetTaskEventsResponseData;
}

export interface GetTaskInfoResponseData {
    /** The user */
    user: User | null;
    /** The company user record of the member the task belongs to. Null when the task has no user, or when no company user could be resolved for them. */
    companyUser: CompanyUser | null;
    /** The user description. */
    userDescription: UserDescription | null;
    /** The user medical information. */
    userMedical: UserMedical | null;
    /** The users contacts. */
    userContacts: Contact[] | null;
    /** The device. */
    device: Device | null;
    /** The teams contacts. */
    teamContacts: Contact[];
    /** The teams contacts schedule. */
    teamContactsSchedule: ContactsSchedule | null;
    /** Whether out of hours is enabled for the team. */
    teamOutOfHoursEnabled: boolean;
    /** The teams out of hours escalation contacts. */
    teamOutOfHoursContacts: Contact[];
    /** The team procedures. */
    teamProcedures: Procedure[];
    /** The team timezone. */
    teamTimezone: string;
}

export interface GetTaskInfoResponse {
    data: GetTaskInfoResponseData;
}

export interface TaskLocations {
    /** The location data. */
    data: TaskLocation[];
    /**
     * The max number of items to return.
     * @example 5000
     */
    limit: number;
    /**
     * The ISO timestamp to start from
     * @example "2021-01-01T00:00:00Z"
     */
    fromTs: string | null;
    /**
     * The next timestamp to start from
     * @example "2021-01-01T00:00:00Z"
     */
    nextTs: string | null;
}

export interface GetTaskLocationsResponseData {
    /** The task locations. */
    locations: TaskLocations;
}

export interface GetTaskLocationsResponse {
    data: GetTaskLocationsResponseData;
}

export interface TeamNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "TEAM_NOT_FOUND" */
    message: 'TEAM_NOT_FOUND';
}

export interface NoPinErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "NO_PIN" */
    message: 'NO_PIN';
}

export interface NoLicenseErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "NO_LICENSE" */
    message: 'NO_LICENSE';
}

export interface CreateReverseGeocodeRequest {
    /** @default null */
    adminArea?: string;
    /** @default null */
    country?: string;
    /** @default null */
    countryISOCode?: string;
    /** @default null */
    locality?: string;
    /** @default null */
    name?: string;
    /** @default null */
    postalCode?: string;
    /** @default null */
    subAdminArea?: string;
    /** @default null */
    subLocality?: string;
    /** @default null */
    subThoroughfare?: string;
    /** @default null */
    thoroughfare?: string;
}

export interface CreateLocationRequest {
    /** The latitude of the location. */
    lat: number;
    /** The longitude of the location. */
    lng: number;
    /**
     * The altitude of the location.
     * @default null
     */
    alt?: number;
    /**
     * The accuracy of the location.
     * @default null
     */
    acc?: number;
    /**
     * The speed of the location.
     * @default null
     */
    speed?: number;
    /**
     * The What3Words address.
     * @default null
     */
    w3w?: string;
    /**
     * The reverse geocode.
     * @default null
     */
    reverseGeocode?: CreateReverseGeocodeRequest;
    /** The timestamp. */
    ts: number;
}

export interface CreateBatteryRequest {
    /** The battery level. */
    level: number;
    /** Whether the device is charging. */
    isCharging: boolean;
    /** The timestamp. */
    ts: number;
}

export interface CreateSignalRequest {
    /**
     * The signal type.
     * @example "WIFI"
     */
    type?: '2G' | '3G' | '4G' | '5G' | 'WIFI' | 'UNKNOWN';
    /** The signal strength. */
    strength?: number;
    /** The signal level, 1-4. */
    level?: number;
    /** The timestamp. */
    ts: number;
}

export interface CreateTaskRequest {
    /** The team id. */
    teamId: string;
    /** The task type. */
    type: 'TIMED' | 'ALERTED';
    /**
     * The task title for a timed task.
     * @default "My task"
     * @example "Client visit."
     */
    title?: string;
    /**
     * The task duration for a timed task. Must conform to team settings (min, max, and increment).
     * @format int32
     * @min 5
     * @max 2000
     * @default 15
     * @example 15
     */
    durationMins?: number;
    /**
     * The alert type for an alerted task.
     * @default "MANUAL_ALERT"
     * @example "MANUAL_ALERT"
     */
    alertType?:
        | 'EXPIRED_ALERT'
        | 'MANUAL_ALERT'
        | 'ACTIVE_MANUAL_ALERT'
        | 'INACTIVE_MANUAL_ALERT'
        | 'DURESS_ALERT'
        | 'CHECK_IN_ALERT'
        | 'FALL_MOTION_ALERT'
        | 'STILL_MOTION_ALERT'
        | 'GEOFENCE_ALERT'
        | 'TILT_ALERT';
    /**
     * The location.
     * @default null
     */
    location?: CreateLocationRequest;
    /**
     * The battery.
     * @default null
     */
    battery?: CreateBatteryRequest;
    /**
     * The signal.
     * @default null
     */
    signal?: CreateSignalRequest;
}

export interface CreateTaskEventResponseData {
    /** The task. */
    task: Task;
    /** The task event. */
    events: TaskEvent[];
}

export interface CreateTaskEventResponse {
    data: CreateTaskEventResponseData;
}

export interface TaskNotActiveErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "TASK_NOT_ACTIVE" */
    message: 'TASK_NOT_ACTIVE';
}

export interface ExtendTaskRequest {
    /**
     * The mins to extend the task by. Must conform to team settings (min, max, and increment).
     * @format int32
     * @min 5
     * @max 2000
     * @default 15
     * @example 15
     */
    additionalMins?: number;
}

export interface AddTaskNoteRequest {
    /**
     * The task note.
     * @minLength 1
     * @maxLength 1000
     * @example "This is a note."
     */
    note: string;
}

export interface TaskNotAlertedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "TASK_NOT_ALERTED" */
    message: 'TASK_NOT_ALERTED';
}

export interface AlreadyAssignedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "ALREADY_ASSIGNED" */
    message: 'ALREADY_ASSIGNED';
}

export interface ResolveTaskRequest {
    /** Whether this is a false alarm or not. Null means undecided. */
    isFalseAlarm: boolean | null;
    /** The reasons for the alert. */
    reasons?: (
        | 'CONTACT_WITH_ELECTRICITY'
        | 'CONTACT_WITH_MACHINERY'
        | 'DROWNED_OR_ASPHYXIATED'
        | 'EXPOSED_TO_EXPLOSION'
        | 'EXPOSED_TO_FIRE'
        | 'EXPOSED_TO_HARMFUL_SUBSTANCE'
        | 'FALL_FROM_HEIGHT'
        | 'INJURED_BY_ANIMAL'
        | 'LIFTING_AND_HANDLING'
        | 'PHYSICAL_ASSAULT_OR_ACT_OF_VIOLENCE'
        | 'SLIP_TRIP_FALL_SAME_HEIGHT'
        | 'STRUCK_AGAINST'
        | 'STRUCK_BY_MOVING_OBJECT'
        | 'STRUCK_BY_OBJECT'
        | 'TRAPPED_BY_SOMETHING_COLLAPSING'
        | 'OTHER'
    )[];
    /** The injury for the alert. */
    injury?: 'NONE' | 'MINOR' | 'MAJOR' | 'UNKNOWN';
    /** The emergency services that were called for the alert */
    emergencyServices?: ('AMBULANCE' | 'FIRE' | 'POLICE')[];
    /**
     * The task note.
     * @example "This is a note."
     */
    note?: string;
}

export interface Teams {
    /** The team data. */
    data: Team[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 10
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetTeamsResponseData {
    /** The paginated teams. */
    teams: Teams;
}

export interface GetTeamsResponse {
    data: GetTeamsResponseData;
}

export interface CompanyUserNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "COMPANY_USER_NOT_FOUND" */
    message: 'COMPANY_USER_NOT_FOUND';
}

export interface TeamCounts {
    /** The non-archived teams in the company */
    total: number;
    /** A map of active (non-archived) team id to the number of non-deleted users assigned to that team, invited and joined alike. Every active team appears, including those with zero users. Company-wide, like the total — never scoped to the requesting user. Example: { "65cca0b3afa103a7c3b8bbcd": 5, "65cca0b3afa103a7c3b8bbce": 0 }. */
    teams: Record<string, number>;
}

export interface GetTeamCountsResponseData {
    /** The company-wide team counts. */
    counts: TeamCounts;
}

export interface GetTeamCountsResponse {
    data: GetTeamCountsResponseData;
}

export interface GetTeamResponseData {
    /** The team. */
    team: Team;
}

export interface GetTeamResponse {
    data: GetTeamResponseData;
}

export interface CannotCreateTeamErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "CANNOT_CREATE_TEAM" */
    message: 'CANNOT_CREATE_TEAM';
}

export interface CreateTeamRequest {
    /** The company id. */
    companyId: string;
    /** The team name */
    name: string;
}

export interface CreateTeamResponseData {
    /** The team */
    team: Team;
    /** The company user. */
    companyUser: CompanyUser;
}

export interface CreateTeamResponse {
    data: CreateTeamResponseData;
}

export interface CannotUpdateTeamErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "CANNOT_UPDATE_TEAM" */
    message: 'CANNOT_UPDATE_TEAM';
}

export interface CannotEnableArcWithoutContactsErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_ENABLE_ARC_WITHOUT_CONTACTS" */
    message: 'CANNOT_ENABLE_ARC_WITHOUT_CONTACTS';
}

export interface CannotRemoveContactsWithArcEnabledErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_REMOVE_CONTACTS_WITH_ARC_ENABLED" */
    message: 'CANNOT_REMOVE_CONTACTS_WITH_ARC_ENABLED';
}

export interface CannotEnableOutOfHoursWithoutContactsErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_ENABLE_OUT_OF_HOURS_WITHOUT_CONTACTS" */
    message: 'CANNOT_ENABLE_OUT_OF_HOURS_WITHOUT_CONTACTS';
}

export interface CannotRemoveOutOfHoursContactsWhenEnabledErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_REMOVE_OUT_OF_HOURS_CONTACTS_WHEN_ENABLED" */
    message: 'CANNOT_REMOVE_OUT_OF_HOURS_CONTACTS_WHEN_ENABLED';
}

export interface InvalidTaskTimeSettingsErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "Minimum time must not be greater than maximum time" */
    message:
        | 'Minimum time must not be greater than maximum time'
        | 'Minimum time must be a multiple of increment'
        | 'Maximum time must be a multiple of increment';
}

export interface UpdateTeamSettings {
    /** Whether the PIN is enabled. */
    pinEnabled?: boolean;
    /** Whether ARC is enabled. */
    arcEnabled?: boolean;
    /** Whether out-of-hours contacts are enabled. */
    outOfHoursEnabled?: boolean;
    /**
     * Minimum task duration in minutes.
     * @min 15
     */
    taskTimeMinMins?: number;
    /**
     * Maximum task duration in minutes.
     * @min 15
     */
    taskTimeMaxMins?: number;
    /**
     * Task duration increment in minutes.
     * @min 5
     * @max 60
     */
    taskTimeIncrementMins?: number;
}

export interface UpdateContact {
    /**
     * The contacts name
     * @example "James"
     */
    name: string;
    /**
     * The contacts role
     * @example "Manager"
     */
    role: string;
    /**
     * The contacts phone number
     * @example "+1234567890"
     */
    phone: string;
}

export interface UpdateContactsScheduleDay {
    /** Whether this is a working day. */
    isWorkingDay: boolean;
    /** Whether working all day (no out-of-hours). Required if isWorkingDay is true. */
    allDay?: boolean;
    /**
     * Start time of working hours in minutes of day (0-1439). Required if isWorkingDay is true and allDay is false.
     * @min 0
     * @max 1438
     */
    startTime?: number;
    /**
     * End time of working hours in minutes of day (0-1439). Required if isWorkingDay is true and allDay is false.
     * @min 1
     * @max 1439
     */
    endTime?: number;
}

export interface UpdateContactsSchedule {
    /** Monday working hours configuration. */
    monday: UpdateContactsScheduleDay;
    /** Tuesday working hours configuration. */
    tuesday: UpdateContactsScheduleDay;
    /** Wednesday working hours configuration. */
    wednesday: UpdateContactsScheduleDay;
    /** Thursday working hours configuration. */
    thursday: UpdateContactsScheduleDay;
    /** Friday working hours configuration. */
    friday: UpdateContactsScheduleDay;
    /** Saturday working hours configuration. */
    saturday: UpdateContactsScheduleDay;
    /** Sunday working hours configuration. */
    sunday: UpdateContactsScheduleDay;
}

export interface UpdateTeamNotification {
    /** Whether the notification is enabled for the app. */
    app: boolean;
    /** Whether the notification is enabled for SMS. */
    sms: boolean;
    /** Whether the notification is enabled for email. */
    email: boolean;
}

export interface UpdateTeamNotifications {
    /** The notification for when a task is started. */
    taskStarted?: UpdateTeamNotification;
    /** The notification for when a task is extended. */
    taskExtended?: UpdateTeamNotification;
    /** The notification for when a task is completed. */
    taskCompleted?: UpdateTeamNotification;
    /** The notification for when a task has a note. */
    taskNote?: UpdateTeamNotification;
    /** The notification for when an alert is triggered. */
    alertTriggered?: UpdateTeamNotification;
    /** The notification for when an alert is assigned. */
    alertAssigned?: UpdateTeamNotification;
    /** The notification for when an alert is unassigned. */
    alertUnassigned?: UpdateTeamNotification;
    /** The notification for when an alert is resolved. */
    alertResolved?: UpdateTeamNotification;
    /** The notification for when a team broadcast is sent. */
    teamBroadcast?: UpdateTeamNotification;
}

export interface UpdateProcedure {
    /** The procedure step. */
    text: string;
}

export interface UpdateTeamRequest {
    /** The team name */
    name?: string;
    /** The team settings. */
    settings?: UpdateTeamSettings;
    /** The team contacts. */
    contacts?: UpdateContact[];
    /** The contacts schedule configuration. */
    contactsSchedule?: UpdateContactsSchedule | null;
    /** The out-of-hours escalation contacts. */
    outOfHoursContacts?: UpdateContact[];
    /** The team notifications. */
    notifications?: UpdateTeamNotifications;
    /** The team procedures. */
    procedures?: UpdateProcedure[];
    /**
     * The team timezone (IANA timezone string).
     * @example "America/New_York"
     */
    timezone?: string;
}

export interface CannotRemoveTeamErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "CANNOT_REMOVE_TEAM" */
    message: 'CANNOT_REMOVE_TEAM';
}

export interface CannotRemoveLastTeamErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_REMOVE_LAST_TEAM" */
    message: 'CANNOT_REMOVE_LAST_TEAM';
}

export interface CannotRemoveTeamWithOpenTasksErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_REMOVE_TEAM_WITH_OPEN_TASKS" */
    message: 'CANNOT_REMOVE_TEAM_WITH_OPEN_TASKS';
}

export interface UserDeviceNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "USER_DEVICE_NOT_FOUND" */
    message: 'USER_DEVICE_NOT_FOUND';
}

export interface UserDeviceFcmNotFoundErrorResponse {
    /** @example 404 */
    statusCode: 404;
    /** @example "USER_DEVICE_FCM_NOT_FOUND" */
    message: 'USER_DEVICE_FCM_NOT_FOUND';
}

export interface SendTestPushNotificationRequest {
    /** The device id */
    deviceId: string;
    /** The notification title text */
    title: string;
    /** The notification body text */
    body: string;
    /** Critical notification flag */
    critical?: boolean;
    /** Android channel ID for the notification */
    androidChannelId?: string;
}

export interface CompanyUsers {
    /** The company user data. */
    data: CompanyUser[];
    /**
     * The offset of the data.
     * @example 0
     */
    offset: number;
    /**
     * The max number of items to return.
     * @example 10
     */
    limit: number;
    /**
     * The total number of items available.
     * @example 34
     */
    total: number;
    /**
     * Indicates if there's anymore data.
     * @example true
     */
    hasMore: boolean;
}

export interface GetUsersPaginatedResponseData {
    /** The company users. */
    users: CompanyUsers;
}

export interface GetUsersPaginatedResponse {
    data: GetUsersPaginatedResponseData;
}

export interface GetCompanyUsersResponseData {
    /** The company users. */
    users: CompanyUser[];
}

export interface GetCompanyUsersResponse {
    data: GetCompanyUsersResponseData;
}

export interface UserCounts {
    /** The non-deleted users in the company, invited and joined alike */
    total: number;
    /** The non-deleted users who have been invited but have not joined yet, including those who declined */
    invited: number;
    /** The non-deleted users whose company role is owner. Roles are mutually exclusive (owner > admin > billing > member), so owner + admin + billing + member equals total. */
    owner: number;
    /** The non-deleted users whose company role is admin */
    admin: number;
    /** The non-deleted users whose company role is billing admin */
    billing: number;
    /** The non-deleted users with no company permissions, whose company role is member */
    member: number;
    /** The joined, non-deleted users whose company role is owner */
    joinedOwner: number;
    /** The joined, non-deleted users whose company role is admin */
    joinedAdmin: number;
    /** The joined, non-deleted users whose company role is billing admin */
    joinedBilling: number;
    /** The joined, non-deleted users whose company role is member */
    joinedMember: number;
    /** The seats purchased on the company's app subscription, or 0 when the company has no app subscription */
    license: number;
    /** The non-deleted users who hold a license, regardless of whether that license is currently within its validity dates */
    assignedLicense: number;
}

export interface GetUserCountsResponseData {
    /** The company-wide user counts. */
    counts: UserCounts;
}

export interface GetUserCountsResponse {
    data: GetUserCountsResponseData;
}

export interface UserAlreadyInvitedOrJoinedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "USER_ALREADY_INVITED_OR_JOINED" */
    message: 'USER_ALREADY_INVITED_OR_JOINED';
}

export interface CannotInviteUsersWithOwnerErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_INVITE_USERS_WITH_OWNER" */
    message: 'CANNOT_INVITE_USERS_WITH_OWNER';
}

export interface CreateCompanyUserInvitesRequest {
    /** The company id */
    companyId: string;
    /** The emails to invite */
    emails?: string[];
    /** The team ids */
    teamIds: string[];
    /** The user company role */
    companyRole: 'owner' | 'admin' | 'billing' | 'member';
    /** The user team roles */
    teamRoles: ('admin' | 'guardian')[];
    /** Whether to assign a license */
    license: boolean;
}

export interface GetUserResponseData {
    /** The company user. */
    user: CompanyUser;
}

export interface GetUserResponse {
    data: GetUserResponseData;
}

export interface IosLocationSettings {
    /**
     * Whether system location services are enabled.
     * @example "yes"
     */
    servicesEnabled?: string;
    /**
     * Location permission granted to the app (authorizedAlways, authorizedWhenInUse, denied, restricted, notDetermined).
     * @example "authorizedAlways"
     */
    permission?: string;
    /**
     * Location accuracy authorization (fullAccuracy, reducedAccuracy).
     * @example "fullAccuracy"
     */
    accuracyAuthorization?: string;
}

export interface IosBluetoothSettings {
    /**
     * Bluetooth permission granted to the app (allowedAlways, denied, restricted, notDetermined).
     * @example "allowedAlways"
     */
    authorization?: string;
}

export interface IosNotificationSettings {
    /**
     * Notification permission granted to the app (authorized, provisional, ephemeral, denied, notDetermined).
     * @example "authorized"
     */
    authorization?: string;
    /**
     * Whether notification sounds are enabled.
     * @example "yes"
     */
    sound?: string;
    /**
     * Whether notification badges are enabled.
     * @example "yes"
     */
    badge?: string;
    /**
     * Whether notification alerts are enabled.
     * @example "yes"
     */
    alert?: string;
    /**
     * Whether critical alerts are enabled.
     * @example "no"
     */
    critical?: string;
}

export interface IosBatteryAndPowerSettings {
    /**
     * Whether low power mode is enabled.
     * @example "no"
     */
    lowPowerMode?: string;
    /**
     * Current battery charging state (charging, full, unplugged, unknown).
     * @example "unplugged"
     */
    batteryState?: string;
    /**
     * Current battery level (0.00–1.00), as a string.
     * @example "0.85"
     */
    batteryLevel?: string;
}

export interface IosAppDeviceSettings {
    /** Location services state and permissions. */
    location?: IosLocationSettings;
    /** Bluetooth permission. */
    bluetooth?: IosBluetoothSettings;
    /** Notification permission and per-channel settings. */
    notifications?: IosNotificationSettings;
    /** Battery and power state. */
    batteryAndPower?: IosBatteryAndPowerSettings;
}

export interface IosAppDevice {
    /**
     * The app device id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /** Unique device identifier reported by the app (UUID or vendor-specific ID). */
    deviceId: string;
    /**
     * Human-readable device name.
     * @example "James's Pixel"
     */
    deviceName: string;
    /**
     * Operating system version.
     * @example "14"
     */
    osVersion: string;
    /**
     * Device manufacturer name.
     * @example "Google"
     */
    manufacturer: string;
    /**
     * Device model name.
     * @example "Pixel 8 Pro"
     */
    model: string;
    /**
     * App version string.
     * @example "2.4.1"
     */
    appVersion: string;
    /**
     * App build number (internal version code).
     * @example "147"
     */
    appBuild: string;
    /**
     * The time the app last checked in. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    lastSeen: string;
    /**
     * The device platform. Always "ios" for this shape.
     * @example "ios"
     */
    platform: 'ios';
    /** Permissions and settings the iOS app reported on check-in. */
    settings: IosAppDeviceSettings;
}

export interface AndroidLocationSettings {
    /**
     * Whether system location services are enabled.
     * @example "yes"
     */
    servicesEnabled?: string;
    /**
     * Whether coarse location permission is granted.
     * @example "yes"
     */
    coarse?: string;
    /**
     * Whether fine location permission is granted.
     * @example "yes"
     */
    fine?: string;
    /**
     * Whether background location permission is granted (API 29+).
     * @example "yes"
     */
    background?: string;
}

export interface AndroidBluetoothSettings {
    /**
     * Whether the Bluetooth adapter is enabled.
     * @example "yes"
     */
    bluetoothEnabled?: string;
    /**
     * Whether the BLUETOOTH permission is granted.
     * @example "yes"
     */
    bluetooth?: string;
    /**
     * Whether the BLUETOOTH_ADMIN permission is granted.
     * @example "yes"
     */
    bluetoothAdmin?: string;
    /**
     * Whether the BLUETOOTH_CONNECT permission is granted (API 31+).
     * @example "yes"
     */
    bluetoothConnect?: string;
    /**
     * Whether the BLUETOOTH_SCAN permission is granted (API 31+).
     * @example "yes"
     */
    bluetoothScan?: string;
    /**
     * Whether the BLUETOOTH_ADVERTISE permission is granted (API 31+).
     * @example "no"
     */
    bluetoothAdvertise?: string;
}

export interface AndroidNotificationSettings {
    /**
     * Whether the POST_NOTIFICATIONS runtime permission is granted (API 33+).
     * @example "yes"
     */
    postNotifications?: string;
    /**
     * Whether the app can schedule exact alarms (API 31+).
     * @example "yes"
     */
    scheduleExactAlarms?: string;
    /**
     * Whether the app has Do Not Disturb (notification policy) access.
     * @example "no"
     */
    notificationPolicyAccess?: string;
    /**
     * Whether notifications are enabled globally for the app.
     * @example "yes"
     */
    notificationsEnabled?: string;
    /**
     * Whether the app may bypass Do Not Disturb / critical alerts (API 28+).
     * @example "no"
     */
    bypassDnd?: string;
}

export interface AndroidBatteryAndPowerSettings {
    /**
     * Whether power saving mode is enabled.
     * @example "no"
     */
    powerSavingMode?: string;
    /**
     * Whether the app is exempt from battery optimizations.
     * @example "yes"
     */
    ignoringBatteryOptimizations?: string;
    /**
     * Whether the app is background-restricted (API 28+).
     * @example "no"
     */
    backgroundRestricted?: string;
}

export interface AndroidNetworkSettings {
    /**
     * Whether the INTERNET permission is granted.
     * @example "yes"
     */
    internetPermission?: string;
}

export interface AndroidStorageSettings {
    /**
     * Whether the READ_EXTERNAL_STORAGE permission is granted.
     * @example "yes"
     */
    readExternal?: string;
    /**
     * Whether the WRITE_EXTERNAL_STORAGE permission is granted.
     * @example "no"
     */
    writeExternal?: string;
    /**
     * Whether the app can manage all external storage (API 30+).
     * @example "no"
     */
    manageExternal?: string;
}

export interface AndroidAppDeviceSettings {
    /** Location services state and permissions. */
    location?: AndroidLocationSettings;
    /** Bluetooth adapter state and permissions. */
    bluetooth?: AndroidBluetoothSettings;
    /** Notification permissions and per-channel settings. */
    notifications?: AndroidNotificationSettings;
    /** Battery and power state. */
    batteryAndPower?: AndroidBatteryAndPowerSettings;
    /** Network permissions. */
    network?: AndroidNetworkSettings;
    /** Storage permissions. */
    storage?: AndroidStorageSettings;
}

export interface AndroidAppDevice {
    /**
     * The app device id.
     * @example "65cca0b3afa103a7c3b8bbcd"
     */
    id: string;
    /** Unique device identifier reported by the app (UUID or vendor-specific ID). */
    deviceId: string;
    /**
     * Human-readable device name.
     * @example "James's Pixel"
     */
    deviceName: string;
    /**
     * Operating system version.
     * @example "14"
     */
    osVersion: string;
    /**
     * Device manufacturer name.
     * @example "Google"
     */
    manufacturer: string;
    /**
     * Device model name.
     * @example "Pixel 8 Pro"
     */
    model: string;
    /**
     * App version string.
     * @example "2.4.1"
     */
    appVersion: string;
    /**
     * App build number (internal version code).
     * @example "147"
     */
    appBuild: string;
    /**
     * The time the app last checked in. ISO 8601 format.
     * @example "2020-01-01T00:00:00.000Z"
     */
    lastSeen: string;
    /**
     * The device platform. Always "android" for this shape.
     * @example "android"
     */
    platform: 'android';
    /** Permissions and settings the Android app reported on check-in. */
    settings: AndroidAppDeviceSettings;
}

export interface GetUserAppDevicesResponseData {
    /** The user's app devices, most recently seen first. Each device is either an iOS or an Android device, discriminated by `platform`. */
    appDevices: (
        | ({
              platform: 'ios';
          } & IosAppDevice)
        | ({
              platform: 'android';
          } & AndroidAppDevice)
    )[];
}

export interface GetUserAppDevicesResponse {
    data: GetUserAppDevicesResponseData;
}

export interface CannotRemoveUserWithOpenTasksErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_REMOVE_USER_WITH_OPEN_TASKS" */
    message: 'CANNOT_REMOVE_USER_WITH_OPEN_TASKS';
}

export interface UpdateUserHeight {
    /**
     * The value
     * @example 180
     */
    value: number;
    /**
     * The unit
     * @example "CM"
     */
    unit: 'CM' | 'INCH';
}

export interface UpdateUserDescriptionRequest {
    /**
     * The users sex. An empty or whitespace-only string is stored as null.
     * @example "male"
     */
    sex?: string | null;
    /**
     * The users dob.
     * @example "male"
     */
    dateOfBirth?: string | null;
    /**
     * The users race. An empty or whitespace-only string is stored as null.
     * @example "male"
     */
    race?: string | null;
    /** The users height. */
    height?: UpdateUserHeight | null;
    /**
     * The users hair colour. An empty or whitespace-only string is stored as null.
     * @example "male"
     */
    hairColour?: string | null;
    /**
     * The users eye colour. An empty or whitespace-only string is stored as null.
     * @example "male"
     */
    eyeColour?: string | null;
    /**
     * Physical identifying of the user. Empty or whitespace-only items are dropped.
     * @example ["Scar on left arm","Tattoo on right arm"]
     */
    identifyingFeatures?: string[];
    /**
     * The users vehicle number plate. An empty or whitespace-only string is stored as null.
     * @example "male"
     */
    vehicleNumberPlate?: string | null;
}

export interface UpdateUserMedicalRequest {
    /**
     * The users blood type. An empty or whitespace-only string is stored as null.
     * @example "male"
     */
    bloodType?: string | null;
    /**
     * The users allergies. Empty or whitespace-only items are dropped.
     * @example ["Peanuts","Dairy"]
     */
    allergies?: string[];
    /**
     * Any medical conditions the user has. Empty or whitespace-only items are dropped.
     * @example ["Diabetes","Asthma"]
     */
    conditions?: string[];
    /**
     * Any medication the user is on. Empty or whitespace-only items are dropped.
     * @example ["Insulin","Ventolin"]
     */
    medication?: string[];
}

export interface UpdateUserNotificationsSettingsItem {
    /** The sound to play for the notification */
    sound?: string;
    /** The critical setting */
    critical: boolean;
    /**
     * The critical volume. Value between 0-1.
     * @example 1
     */
    criticalVolume: number;
}

export interface UpdateUserNotificationsSettings {
    /** The task timeout notification settings. */
    taskTimeout: UpdateUserNotificationsSettingsItem;
    /** The task 5 min notification reminder settings. */
    task5Min: UpdateUserNotificationsSettingsItem;
    /** The task 10 min notification reminder settings. */
    task10Min: UpdateUserNotificationsSettingsItem;
}

export interface UpdateUserGuardianNotification {
    /** Whether the notification is enabled for the app. Omit or send null to use the team setting. */
    app?: boolean | null;
    /** Whether the notification is enabled for SMS. Omit or send null to use the team setting. */
    sms?: boolean | null;
    /** Whether the notification is enabled for email. Omit or send null to use the team setting. */
    email?: boolean | null;
}

export interface UpdateUserGuardianNotifications {
    /** The users preference for when a task is started. */
    taskStarted?: UpdateUserGuardianNotification;
    /** The users preference for when a task is extended. */
    taskExtended?: UpdateUserGuardianNotification;
    /** The users preference for when a task is completed. */
    taskCompleted?: UpdateUserGuardianNotification;
    /** The users preference for when a task has a note. */
    taskNote?: UpdateUserGuardianNotification;
    /** The users preference for when an alert is triggered. */
    alertTriggered?: UpdateUserGuardianNotification;
    /** The users preference for when an alert is assigned. */
    alertAssigned?: UpdateUserGuardianNotification;
    /** The users preference for when an alert is unassigned. */
    alertUnassigned?: UpdateUserGuardianNotification;
    /** The users preference for when an alert is resolved. */
    alertResolved?: UpdateUserGuardianNotification;
}

export interface UpdateCompanyUserRequest {
    /** The users first name */
    firstName?: string;
    /** The users last name */
    lastName?: string;
    /** The users description. */
    description?: UpdateUserDescriptionRequest;
    /** The users medical details. */
    medical?: UpdateUserMedicalRequest;
    /** The user next of kin. */
    nextOfKin?: UpdateContact[];
    /**
     * The users language (IETF language tag).
     * @example "en-gb"
     */
    language?: string;
    /** The users notification settings. */
    notifications?: UpdateUserNotificationsSettings;
    /** The users personal notification preferences. Replaces the whole object: any event or channel omitted (or null) uses the team setting. Send {} to reset all preferences. */
    guardianNotifications?: UpdateUserGuardianNotifications;
    /**
     * The users timezone (IANA timezone identifier).
     * @example "Europe/London"
     */
    timezone?: string;
    /** Whether to automatically detect the users timezone. */
    timezoneAutoDetect?: boolean;
    /** Whether to use 24-hour clock format. */
    use24HourClock?: boolean;
    /**
     * The device power mode.
     * @example "NORMAL"
     */
    powerMode?: 'NORMAL' | 'LOW';
}

export interface AddPhoneRequest {
    /** The users phone number */
    phone: string;
}

export interface VerifyPhoneRequest {
    /** The users phone number */
    phone: string;
    /** The 6-digit verification code send to the phone. */
    code: string;
}

export interface CannotAssignOwnerRoleErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "CANNOT_ASSIGN_OWNER_ROLE" */
    message: 'CANNOT_ASSIGN_OWNER_ROLE';
}

export interface CannotRemoveLastOwnerErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "CANNOT_REMOVE_LAST_OWNER" */
    message: 'CANNOT_REMOVE_LAST_OWNER';
}

export interface UpdateUserCompanyRolesRequest {
    /** The user role */
    role: 'owner' | 'admin' | 'billing' | 'member';
}

export interface UpdateUserCompanyLicense {
    /** The date the license is valid from in ISO 8601 */
    validFrom: string;
    /** The date the license is valid to in ISO 8601. Null if it never expires */
    validTo: string | null;
}

export interface UpdateUserCompanyLicenseRequest {
    /** The users license */
    license: UpdateUserCompanyLicense | null;
}

export interface UserAlreadyJoinedErrorResponse {
    /** @example 403 */
    statusCode: 403;
    /** @example "USER_ALREADY_JOINED" */
    message: 'USER_ALREADY_JOINED';
}

export interface UserAlreadyInTeamErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "USER_ALREADY_IN_TEAM" */
    message: 'USER_ALREADY_IN_TEAM';
}

export interface CreateTeamUserTeamRoles {
    /** The admin role */
    admin?: boolean;
    /** The guardian role */
    guardian?: boolean;
}

export interface CreateTeamUserRequest {
    /** The team id */
    teamId: string;
    /** The user team roles. */
    roles: CreateTeamUserTeamRoles;
}

export interface UserNotInTeamErrorResponse {
    /** @example 400 */
    statusCode: 400;
    /** @example "USER_NOT_IN_TEAM" */
    message: 'USER_NOT_IN_TEAM';
}

export interface UpdateUserTeamRolesRequest {
    /** The user team roles */
    roles: ('admin' | 'guardian')[];
}

export interface GetW3WResponseData {
    /** The What3Words address. */
    words: string;
}

export interface GetW3WResponse {
    data: GetW3WResponseData;
}

import type {
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
    HeadersDefaults,
    ResponseType
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
    extends Omit<
        AxiosRequestConfig,
        'data' | 'params' | 'url' | 'responseType'
    > {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType;
    /** request body */
    body?: unknown;
}

export type RequestParams = Omit<
    FullRequestParams,
    'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
    extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
    secure?: boolean;
    format?: ResponseType;
}

export enum ContentType {
    Json = 'application/json',
    JsonApi = 'application/vnd.api+json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
    public instance: AxiosInstance;
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private secure?: boolean;
    private format?: ResponseType;

    constructor({
        securityWorker,
        secure,
        format,
        ...axiosConfig
    }: ApiConfig<SecurityDataType> = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || ''
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected mergeRequestParams(
        params1: AxiosRequestConfig,
        params2?: AxiosRequestConfig
    ): AxiosRequestConfig {
        const method = params1.method || (params2 && params2.method);

        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method &&
                    this.instance.defaults.headers[
                        method.toLowerCase() as keyof HeadersDefaults
                    ]) ||
                    {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {})
            }
        };
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        } else {
            return `${formItem}`;
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        if (input instanceof FormData) {
            return input;
        }
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent: any[] =
                property instanceof Array ? property : [property];

            for (const formItem of propertyContent) {
                const isFileType =
                    formItem instanceof Blob || formItem instanceof File;
                formData.append(
                    key,
                    isFileType ? formItem : this.stringifyFormItem(formItem)
                );
            }

            return formData;
        }, new FormData());
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;

        if (
            type === ContentType.FormData &&
            body &&
            body !== null &&
            typeof body === 'object'
        ) {
            body = this.createFormData(body as Record<string, unknown>);
        }

        if (
            type === ContentType.Text &&
            body &&
            body !== null &&
            typeof body !== 'string'
        ) {
            body = JSON.stringify(body);
        }

        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type ? { 'Content-Type': type } : {})
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path
        });
    };
}

/**
 * @title Safepoint Public API
 * @version 3.215.0
 * @contact
 */
export class Api<
    SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
    analytics = {
        /**
         * No description
         *
         * @tags analytics
         * @name GetTasksAndAlerts
         * @request GET:/v3/analytics/tasks-and-alerts
         * @secure
         */
        getTasksAndAlerts: (
            query?: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /** The team ids */
                teamIds?: string[];
                /** The user ids */
                userIds?: string[];
                /** If true, userIds are treated as company user ids instead of user (account) ids. */
                useNewUserSystem?: boolean;
                /** The device ids */
                deviceIds?: string[];
                /**
                 * Return all tasks on or after this date.
                 * @format date-time
                 */
                from?: string;
                /**
                 * Return all tasks on or before this date.
                 * @format date-time
                 */
                to?: string;
                /**
                 * The unit of time for the analytics data
                 * @example "daily"
                 */
                unit?: 'daily' | 'weekly' | 'monthly';
                /**
                 * The timezone to use for the date range.
                 * @example "Europe/London"
                 */
                tz?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetTasksAndAlertsAnalyticsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
            >({
                path: `/v3/analytics/tasks-and-alerts`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags analytics
         * @name GetTasksAndAlertsHourlyActivity
         * @request GET:/v3/analytics/tasks-and-alerts-hourly-activity
         * @secure
         */
        getTasksAndAlertsHourlyActivity: (
            query?: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /** The team ids */
                teamIds?: string[];
                /** The user ids */
                userIds?: string[];
                /** If true, userIds are treated as company user ids instead of user (account) ids. */
                useNewUserSystem?: boolean;
                /** The device ids */
                deviceIds?: string[];
                /**
                 * Return all tasks on or after this date in UTC.
                 * @format date-time
                 */
                from?: string;
                /**
                 * Return all tasks on or before this date in UTC.
                 * @format date-time
                 */
                to?: string;
                /**
                 * The timezone to use for the date range.
                 * @example "Europe/London"
                 */
                tz?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetTasksAndAlertsHourlyActivityAnalyticsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
            >({
                path: `/v3/analytics/tasks-and-alerts-hourly-activity`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags analytics
         * @name GetTeamActivity
         * @request GET:/v3/analytics/team-activity
         * @secure
         */
        getTeamActivity: (
            query?: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /** The team ids */
                teamIds?: string[];
                /** The user ids */
                userIds?: string[];
                /** If true, userIds are treated as company user ids instead of user (account) ids. */
                useNewUserSystem?: boolean;
                /** The device ids */
                deviceIds?: string[];
                /**
                 * Return all tasks on or after this date in UTC.
                 * @format date-time
                 */
                from?: string;
                /**
                 * Return all tasks on or before this date in UTC.
                 * @format date-time
                 */
                to?: string;
                /**
                 * The timezone to use for the date range.
                 * @example "Europe/London"
                 */
                tz?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetActivityAnalyticsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
            >({
                path: `/v3/analytics/team-activity`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags analytics
         * @name GetUserActivity
         * @request GET:/v3/analytics/user-activity
         * @secure
         */
        getUserActivity: (
            query?: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /** The team ids */
                teamIds?: string[];
                /** The user ids */
                userIds?: string[];
                /** If true, userIds are treated as company user ids instead of user (account) ids. */
                useNewUserSystem?: boolean;
                /** The device ids */
                deviceIds?: string[];
                /**
                 * Return all tasks on or after this date in UTC.
                 * @format date-time
                 */
                from?: string;
                /**
                 * Return all tasks on or before this date in UTC.
                 * @format date-time
                 */
                to?: string;
                /**
                 * The timezone to use for the date range.
                 * @example "Europe/London"
                 */
                tz?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetActivityAnalyticsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
            >({
                path: `/v3/analytics/user-activity`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags analytics
         * @name GetLocations
         * @request GET:/v3/analytics/locations
         * @secure
         */
        getLocations: (
            query?: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /** The team ids */
                teamIds?: string[];
                /** The user ids */
                userIds?: string[];
                /** If true, userIds are treated as company user ids instead of user (account) ids. */
                useNewUserSystem?: boolean;
                /** The device ids */
                deviceIds?: string[];
                /**
                 * Return all tasks on or after this date.
                 * @format date-time
                 */
                from?: string;
                /**
                 * Return all tasks on or before this date.
                 * @format date-time
                 */
                to?: string;
                /**
                 * The maximum number of results to return.
                 * @example 10000
                 */
                limit?: number;
                /** The cursor for pagination. */
                cursor?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetLocationAnalyticsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
            >({
                path: `/v3/analytics/locations`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            })
    };
    auth = {
        /**
         * @description Creates an account. Supply the `token` from POST /v3/auth/signup/verify-email/confirm to register a verified email address. Supplying `email` instead is deprecated and creates the account unverified.
         *
         * @tags auth
         * @name Signup
         * @request POST:/v3/auth/signup
         */
        signup: (data: SignupRequest, params: RequestParams = {}) =>
            this.request<
                SignupResponse,
                | (
                      | ValidationErrorResponse
                      | InvalidTokenErrorResponse
                      | EmailBlockedErrorResponse
                      | UserAlreadyExistsErrorResponse
                  )
                | (AppCheckErrorResponse | IpBlockedErrorResponse)
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/signup`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Step one of registration. Sends a 6 character code to the address so it can be verified before the account is created. The code expires in 15 minutes. Calling it again for the same address sends a fresh code and invalidates the previous one.
         *
         * @tags auth
         * @name RequestSignupEmailVerification
         * @request POST:/v3/auth/signup/verify-email
         */
        requestSignupEmailVerification: (
            data: RequestSignupEmailVerificationRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                void,
                | (
                      | ValidationErrorResponse
                      | EmailBlockedErrorResponse
                      | UserAlreadyExistsErrorResponse
                  )
                | (AppCheckErrorResponse | IpBlockedErrorResponse)
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/signup/verify-email`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params
            }),

        /**
         * @description Step two of registration. Exchanges the code from the verification email for the registration token that POST /v3/auth/signup redeems. The code stays valid until it expires, so repeating the call returns the same token.
         *
         * @tags auth
         * @name ConfirmSignupEmailVerification
         * @request POST:/v3/auth/signup/verify-email/confirm
         */
        confirmSignupEmailVerification: (
            data: ConfirmSignupEmailVerificationRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                ConfirmSignupEmailVerificationResponse,
                | (
                      | ValidationErrorResponse
                      | IncorrectCodeErrorResponse
                      | TooManyCodeAttemptsErrorResponse
                  )
                | AppCheckErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/signup/verify-email/confirm`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name Login
         * @request POST:/v3/auth/login
         */
        login: (data: LoginRequest, params: RequestParams = {}) =>
            this.request<
                LoginResponse,
                | ValidationErrorResponse
                | InvalidCredentialsErrorResponse
                | AppCheckErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/login`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Exchanges a Google or Microsoft OIDC ID token for Safepoint tokens. Send the ID token from the native provider SDK, not the access token. If an account already exists for the provider-verified email address the identity is linked to it and the user is signed in; otherwise an account is created from the token claims. On a 400 CONSENT_REQUIRED, show the consent screen, obtain a FRESH ID token from the provider SDK, and retry with termsOfService, privacyPolicy and over16 set to true — the provider session is cached so this is silent, and the original token will have aged out.
         *
         * @tags auth
         * @name SsoLogin
         * @request POST:/v3/auth/sso
         */
        ssoLogin: (data: SsoLoginRequest, params: RequestParams = {}) =>
            this.request<
                SsoLoginResponse,
                | (
                      | ValidationErrorResponse
                      | ConsentRequiredErrorResponse
                      | SsoProviderNotConfiguredErrorResponse
                      | EmailBlockedErrorResponse
                      | UserAlreadyExistsErrorResponse
                  )
                | InvalidSsoTokenErrorResponse
                | (
                      | AppCheckErrorResponse
                      | IpBlockedErrorResponse
                      | SsoEmailNotVerifiedErrorResponse
                      | SsoAccountTypeNotSupportedErrorResponse
                  )
                | SsoIdentityAlreadyLinkedErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/sso`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name Refresh
         * @request POST:/v3/auth/refresh
         */
        refresh: (data: RefreshRequest, params: RequestParams = {}) =>
            this.request<
                RefreshResponse,
                | ValidationErrorResponse
                | UnauthorisedErrorResponse
                | UserNotFoundErrorResponse
            >({
                path: `/v3/auth/refresh`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name Logout
         * @request POST:/v3/auth/logout
         * @secure
         */
        logout: (data: LogoutRequest, params: RequestParams = {}) =>
            this.request<
                void,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/auth/logout`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name ForgotPassword
         * @request POST:/v3/auth/password/forgot
         */
        forgotPassword: (
            data: ForgotPasswordRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                void,
                | ValidationErrorResponse
                | AppCheckErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/password/forgot`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name ResetPassword
         * @request POST:/v3/auth/password/reset
         */
        resetPassword: (
            data: ResetPasswordRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                void,
                | (ValidationErrorResponse | InvalidTokenErrorResponse)
                | AppCheckErrorResponse
                | UserNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/password/reset`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name VerifyEmail
         * @request POST:/v3/auth/email/verify
         */
        verifyEmail: (data: VerifyEmailRequest, params: RequestParams = {}) =>
            this.request<
                void,
                | (ValidationErrorResponse | IncorrectTokenErrorResponse)
                | AppCheckErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/email/verify`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name VerifyNewEmail
         * @request POST:/v3/auth/email/new/verify
         */
        verifyNewEmail: (
            data: VerifyEmailRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                void,
                | (ValidationErrorResponse | IncorrectTokenErrorResponse)
                | AppCheckErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/auth/email/new/verify`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params
            })
    };
    broadcasts = {
        /**
         * No description
         *
         * @tags broadcasts
         * @name SendBroadcast
         * @request POST:/v3/broadcasts
         * @secure
         */
        sendBroadcast: (
            data: SendBroadcastRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                void,
                | (ValidationErrorResponse | InvalidTeamErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | AppCheckErrorResponse
                      | NotSubscribedErrorResponse
                      | NoSmsSubscriptionErrorResponse
                  )
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/broadcasts`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            })
    };
    companies = {
        /**
         * No description
         *
         * @tags companies
         * @name CreateCompany
         * @request POST:/v3/companies
         * @secure
         */
        createCompany: (
            data: CreateCompanyRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                CreateCompanyResponse,
                | (
                      | ValidationErrorResponse
                      | CannotInviteYourselfErrorResponse
                      | DuplicateUsersErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | AppCheckErrorResponse
                | UserNotFoundErrorResponse
            >({
                path: `/v3/companies`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name GetCompanies
         * @request GET:/v3/companies
         * @secure
         */
        getCompanies: (params: RequestParams = {}) =>
            this.request<
                GetCompaniesResponse,
                UnauthorisedErrorResponse | TokenExpiredErrorResponse
            >({
                path: `/v3/companies`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name GetCompany
         * @request GET:/v3/companies/{companyId}
         * @secure
         */
        getCompany: (companyId: string, params: RequestParams = {}) =>
            this.request<
                CompanyResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name UpdateCompany
         * @request PATCH:/v3/companies/{companyId}
         * @secure
         */
        updateCompany: (
            companyId: string,
            data: UpdateCompanyRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                CompanyResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name UploadCompanyImage
         * @request POST:/v3/companies/{companyId}/image
         * @secure
         */
        uploadCompanyImage: (
            companyId: string,
            data: {
                /** @format binary */
                file?: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                CompanyResponse,
                | (
                      | ValidationErrorResponse
                      | FileRequiredErrorResponse
                      | CannotProcessFileErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/image`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name EnableSms
         * @request POST:/v3/companies/{companyId}/sms/enable
         * @secure
         */
        enableSms: (companyId: string, params: RequestParams = {}) =>
            this.request<
                CompanyResponse,
                | (ValidationErrorResponse | NoSmsPaymentMethodErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | ForbiddenUnauthorisedErrorResponse
                      | SmsAlreadyEnabledErrorResponse
                  )
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/sms/enable`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name DisableSms
         * @request POST:/v3/companies/{companyId}/sms/disable
         * @secure
         */
        disableSms: (companyId: string, params: RequestParams = {}) =>
            this.request<
                CompanyResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | ForbiddenUnauthorisedErrorResponse
                      | SmsAlreadyDisabledErrorResponse
                  )
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/sms/disable`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name GetSmsUsage
         * @request GET:/v3/companies/{companyId}/sms/usage
         * @secure
         */
        getSmsUsage: (companyId: string, params: RequestParams = {}) =>
            this.request<
                SmsUsageResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | ForbiddenUnauthorisedErrorResponse
                      | NoSmsSubscriptionErrorResponse
                  )
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/sms/usage`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name CreateStripeCheckoutSession
         * @request POST:/v3/companies/{companyId}/subscriptions/stripe/create-checkout-session
         * @secure
         */
        createStripeCheckoutSession: (
            companyId: string,
            data: CreateStripeCheckoutRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                StripeRedirectResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | ForbiddenUnauthorisedErrorResponse
                      | AlreadySubscribedErrorResponse
                  )
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/subscriptions/stripe/create-checkout-session`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name CreateStripePortalSession
         * @request POST:/v3/companies/{companyId}/subscriptions/stripe/create-portal-session
         * @secure
         */
        createStripePortalSession: (
            companyId: string,
            data: CreateStripePortalRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                StripeRedirectResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/subscriptions/stripe/create-portal-session`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name CreateStripeUpdatePortalSession
         * @request POST:/v3/companies/{companyId}/subscriptions/stripe/create-update-portal-session
         * @secure
         */
        createStripeUpdatePortalSession: (
            companyId: string,
            data: CreateStripePortalRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                StripeRedirectResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/subscriptions/stripe/create-update-portal-session`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name CreateStripeCancelPortalSession
         * @request POST:/v3/companies/{companyId}/subscriptions/stripe/create-cancel-portal-session
         * @secure
         */
        createStripeCancelPortalSession: (
            companyId: string,
            data: CreateStripePortalRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                StripeRedirectResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/subscriptions/stripe/create-cancel-portal-session`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name CreateStripePaymentMethodPortalSession
         * @request POST:/v3/companies/{companyId}/subscriptions/stripe/create-payment-method-portal-session
         * @secure
         */
        createStripePaymentMethodPortalSession: (
            companyId: string,
            data: CreateStripePortalRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                StripeRedirectResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/subscriptions/stripe/create-payment-method-portal-session`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags companies
         * @name GetSubscriptionUsage
         * @request GET:/v3/companies/{companyId}/subscriptions/usage
         * @secure
         */
        getSubscriptionUsage: (companyId: string, params: RequestParams = {}) =>
            this.request<
                SubscriptionUsageResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/companies/${companyId}/subscriptions/usage`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            })
    };
    devices = {
        /**
         * No description
         *
         * @tags devices
         * @name CreateBeacon
         * @request POST:/v3/devices/beacons
         * @secure
         */
        createBeacon: (data: CreateBeaconRequest, params: RequestParams = {}) =>
            this.request<
                GetBeaconResponse,
                | (ValidationErrorResponse | BeaconAlreadyExistsErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/devices/beacons`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name GetBeacons
         * @request GET:/v3/devices/beacons
         * @secure
         */
        getBeacons: (
            query: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetBeaconsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenErrorResponse
                | CompanyNotFoundErrorResponse
            >({
                path: `/v3/devices/beacons`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name GetBeacon
         * @request GET:/v3/devices/beacons/{beaconId}
         * @secure
         */
        getBeacon: (beaconId: string, params: RequestParams = {}) =>
            this.request<
                GetBeaconResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | BeaconNotFoundErrorResponse
            >({
                path: `/v3/devices/beacons/${beaconId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name UpdateBeacon
         * @request PATCH:/v3/devices/beacons/{beaconId}
         * @secure
         */
        updateBeacon: (
            beaconId: string,
            data: UpdateBeaconRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetBeaconResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | BeaconNotFoundErrorResponse
            >({
                path: `/v3/devices/beacons/${beaconId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name DeleteBeacon
         * @request DELETE:/v3/devices/beacons/{beaconId}
         * @secure
         */
        deleteBeacon: (beaconId: string, params: RequestParams = {}) =>
            this.request<
                void,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | BeaconNotFoundErrorResponse
            >({
                path: `/v3/devices/beacons/${beaconId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkAssignDeviceTeam
         * @request POST:/v3/devices/bulk/assign
         * @secure
         */
        bulkAssignDeviceTeam: (
            data: BulkAssignDeviceTeamRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | (
                      | ValidationErrorResponse
                      | InvalidTeamErrorResponse
                      | InvalidUserErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/assign`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name GetDevices
         * @request GET:/v3/devices
         * @secure
         */
        getDevices: (
            query?: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 25
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/devices`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name TestDevice
         * @request POST:/v3/devices/{deviceId}/test
         * @secure
         */
        testDevice: (deviceId: string, params: RequestParams = {}) =>
            this.request<
                DeviceTestResponse,
                | (
                      | ValidationErrorResponse
                      | DeviceNoPhoneErrorResponse
                      | DeviceNoSmsPasswordErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | AppCheckErrorResponse
                | DeviceNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/devices/${deviceId}/test`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name GetDeviceTestStatus
         * @request GET:/v3/devices/{deviceId}/test/{statusId}
         * @secure
         */
        getDeviceTestStatus: (
            deviceId: string,
            statusId: string,
            query?: {
                /** Whether to poll call status from Twilio. Defaults to true. Set to false to skip. */
                pollCall?: string;
                /** Whether to poll SMS status. Defaults to true. Set to false to skip. */
                pollSms?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                DeviceTestStatusResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | AppCheckErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/test/${statusId}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name GetDevice
         * @request GET:/v3/devices/{deviceId}
         * @secure
         */
        getDevice: (deviceId: string, params: RequestParams = {}) =>
            this.request<
                GetDeviceResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name UpdateDevice
         * @request PATCH:/v3/devices/{deviceId}
         * @secure
         */
        updateDevice: (
            deviceId: string,
            data: UpdateDeviceRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | (
                      | ValidationErrorResponse
                      | InvalidTeamErrorResponse
                      | InvalidUserErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (DeviceNotFoundErrorResponse | CompanyNotFoundErrorResponse)
            >({
                path: `/v3/devices/${deviceId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name AssignDevice
         * @request POST:/v3/devices/{deviceId}/assign
         * @secure
         */
        assignDevice: (
            deviceId: string,
            data: AssignDeviceRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | InvalidTeamErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/assign`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name ActivateDevice
         * @request POST:/v3/devices/{deviceId}/activate
         * @secure
         */
        activateDevice: (
            deviceId: string,
            data: ActivateDeviceRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | DeviceNotFoundErrorResponse
                | (DeviceAlreadyActivatedErrorResponse | SimClosedErrorResponse)
            >({
                path: `/v3/devices/${deviceId}/activate`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkRebootDevices
         * @request POST:/v3/devices/bulk/actions/reboot
         * @secure
         */
        bulkRebootDevices: (
            data: BulkDeviceIdsRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/actions/reboot`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkCancelDeviceReboot
         * @request DELETE:/v3/devices/bulk/actions/reboot
         * @secure
         */
        bulkCancelDeviceReboot: (
            data: BulkDeviceIdsRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/actions/reboot`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkPowerOffDevices
         * @request POST:/v3/devices/bulk/actions/power-off
         * @secure
         */
        bulkPowerOffDevices: (
            data: BulkDeviceIdsRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/actions/power-off`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkCancelDevicePowerOff
         * @request DELETE:/v3/devices/bulk/actions/power-off
         * @secure
         */
        bulkCancelDevicePowerOff: (
            data: BulkDeviceIdsRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/actions/power-off`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkUpdateDeviceConfigFallAlert
         * @request PATCH:/v3/devices/bulk/config/fall-alert
         * @secure
         */
        bulkUpdateDeviceConfigFallAlert: (
            data: BulkUpdateDeviceConfigFallAlertRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/fall-alert`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkUpdateDeviceConfigTiltAlert
         * @request PATCH:/v3/devices/bulk/config/tilt-alert
         * @secure
         */
        bulkUpdateDeviceConfigTiltAlert: (
            data: BulkUpdateDeviceConfigTiltAlertRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/tilt-alert`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkUpdateDeviceConfigWifi
         * @request PATCH:/v3/devices/bulk/config/wifi
         * @secure
         */
        bulkUpdateDeviceConfigWifi: (
            data: BulkUpdateDeviceConfigWifiRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/wifi`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkUpdateDeviceConfigGeoAlert
         * @request PATCH:/v3/devices/bulk/config/geofence
         * @secure
         */
        bulkUpdateDeviceConfigGeoAlert: (
            data: BulkUpdateDeviceConfigGeoAlertRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/geofence`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkCancelDeviceConfigFallAlert
         * @request DELETE:/v3/devices/bulk/config/fall-alert/pending
         * @secure
         */
        bulkCancelDeviceConfigFallAlert: (
            data: BulkDeviceIdsRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/fall-alert/pending`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkCancelDeviceConfigTiltAlert
         * @request DELETE:/v3/devices/bulk/config/tilt-alert/pending
         * @secure
         */
        bulkCancelDeviceConfigTiltAlert: (
            data: BulkDeviceIdsRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/tilt-alert/pending`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkCancelDeviceConfigWifi
         * @request DELETE:/v3/devices/bulk/config/wifi/pending
         * @secure
         */
        bulkCancelDeviceConfigWifi: (
            data: BulkCancelDeviceConfigWifiRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/wifi/pending`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name BulkCancelDeviceConfigGeoAlert
         * @request DELETE:/v3/devices/bulk/config/geofence/pending
         * @secure
         */
        bulkCancelDeviceConfigGeoAlert: (
            data: BulkCancelDeviceConfigGeoAlertRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                BulkDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | (CompanyNotFoundErrorResponse | DeviceNotFoundErrorResponse)
            >({
                path: `/v3/devices/bulk/config/geofence/pending`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name RebootDevice
         * @request POST:/v3/devices/{deviceId}/actions/reboot
         * @secure
         */
        rebootDevice: (deviceId: string, params: RequestParams = {}) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/actions/reboot`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name CancelDeviceReboot
         * @request DELETE:/v3/devices/{deviceId}/actions/reboot
         * @secure
         */
        cancelDeviceReboot: (deviceId: string, params: RequestParams = {}) =>
            this.request<
                GetDeviceResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/actions/reboot`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name PowerOffDevice
         * @request POST:/v3/devices/{deviceId}/actions/power-off
         * @secure
         */
        powerOffDevice: (deviceId: string, params: RequestParams = {}) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/actions/power-off`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name CancelDevicePowerOff
         * @request DELETE:/v3/devices/{deviceId}/actions/power-off
         * @secure
         */
        cancelDevicePowerOff: (deviceId: string, params: RequestParams = {}) =>
            this.request<
                GetDeviceResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/actions/power-off`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name UpdateDeviceConfigFallAlert
         * @request PATCH:/v3/devices/{deviceId}/config/fall-alert
         * @secure
         */
        updateDeviceConfigFallAlert: (
            deviceId: string,
            data: UpdateDeviceConfigFallAlertRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/fall-alert`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name UpdateDeviceConfigTiltAlert
         * @request PATCH:/v3/devices/{deviceId}/config/tilt-alert
         * @secure
         */
        updateDeviceConfigTiltAlert: (
            deviceId: string,
            data: UpdateDeviceConfigTiltAlertRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/tilt-alert`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name UpdateDeviceConfigWifi
         * @request PATCH:/v3/devices/{deviceId}/config/wifi/{slot}
         * @secure
         */
        updateDeviceConfigWifi: (
            deviceId: string,
            slot: string,
            data: UpdateDeviceConfigWifiRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/wifi/${slot}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name UpdateDeviceConfigGeoAlert
         * @request PATCH:/v3/devices/{deviceId}/config/geofence/{slot}
         * @secure
         */
        updateDeviceConfigGeoAlert: (
            deviceId: string,
            slot: string,
            data: UpdateDeviceConfigGeoAlertRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | (ValidationErrorResponse | DeviceNotSetupErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/geofence/${slot}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name CancelDeviceConfigFallAlert
         * @request DELETE:/v3/devices/{deviceId}/config/fall-alert/pending
         * @secure
         */
        cancelDeviceConfigFallAlert: (
            deviceId: string,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/fall-alert/pending`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name CancelDeviceConfigTiltAlert
         * @request DELETE:/v3/devices/{deviceId}/config/tilt-alert/pending
         * @secure
         */
        cancelDeviceConfigTiltAlert: (
            deviceId: string,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/tilt-alert/pending`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name CancelDeviceConfigWifi
         * @request DELETE:/v3/devices/{deviceId}/config/wifi/{slot}/pending
         * @secure
         */
        cancelDeviceConfigWifi: (
            deviceId: string,
            slot: string,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/wifi/${slot}/pending`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags devices
         * @name CancelDeviceConfigGeoAlert
         * @request DELETE:/v3/devices/{deviceId}/config/geofence/{slot}/pending
         * @secure
         */
        cancelDeviceConfigGeoAlert: (
            deviceId: string,
            slot: string,
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | NoPermissionErrorResponse
                | DeviceNotFoundErrorResponse
            >({
                path: `/v3/devices/${deviceId}/config/geofence/${slot}/pending`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            })
    };
    filters = {
        /**
         * No description
         *
         * @tags filters
         * @name GetTeamFilterOptions
         * @request GET:/v3/filters/teams
         * @secure
         */
        getTeamFilterOptions: (
            query: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 25
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId: string;
                /**
                 * Case-insensitive substring match on the option name.
                 * @example "north"
                 */
                search?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetFilterOptionsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/filters/teams`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags filters
         * @name GetUserFilterOptions
         * @request GET:/v3/filters/users
         * @secure
         */
        getUserFilterOptions: (
            query: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 25
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId: string;
                /**
                 * Case-insensitive substring match on the option name.
                 * @example "north"
                 */
                search?: string;
                /**
                 * Restrict the results to these teams. Intersected with the teams the requesting user may see - it never widens their scope.
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                teamIds?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetFilterOptionsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/filters/users`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags filters
         * @name GetDeviceFilterOptions
         * @request GET:/v3/filters/devices
         * @secure
         */
        getDeviceFilterOptions: (
            query: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 25
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId: string;
                /**
                 * Case-insensitive substring match on the option name.
                 * @example "north"
                 */
                search?: string;
                /**
                 * Restrict the results to these teams. Intersected with the teams the requesting user may see - it never widens their scope.
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                teamIds?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetDeviceFilterOptionsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/filters/devices`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            })
    };
    geo = {
        /**
         * No description
         *
         * @tags geo
         * @name GetGeoLocation
         * @request GET:/v3/geo/location
         */
        getGeoLocation: (params: RequestParams = {}) =>
            this.request<GetLocationResponse, AppCheckErrorResponse>({
                path: `/v3/geo/location`,
                method: 'GET',
                format: 'json',
                ...params
            })
    };
    health = {
        /**
         * No description
         *
         * @tags health
         * @name Health
         * @request GET:/v3/health
         */
        health: (params: RequestParams = {}) =>
            this.request<
                {
                    /** @example "ok" */
                    status?: string;
                    /** @example {"database":{"status":"up"}} */
                    info?: Record<
                        string,
                        {
                            status: string;
                            [key: string]: any;
                        }
                    >;
                    /** @example {} */
                    error?: Record<
                        string,
                        {
                            status: string;
                            [key: string]: any;
                        }
                    >;
                    /** @example {"database":{"status":"up"}} */
                    details?: Record<
                        string,
                        {
                            status: string;
                            [key: string]: any;
                        }
                    >;
                },
                {
                    /** @example "error" */
                    status?: string;
                    /** @example {"database":{"status":"up"}} */
                    info?: Record<
                        string,
                        {
                            status: string;
                            [key: string]: any;
                        }
                    >;
                    /** @example {"redis":{"status":"down","message":"Could not connect"}} */
                    error?: Record<
                        string,
                        {
                            status: string;
                            [key: string]: any;
                        }
                    >;
                    /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
                    details?: Record<
                        string,
                        {
                            status: string;
                            [key: string]: any;
                        }
                    >;
                }
            >({
                path: `/v3/health`,
                method: 'GET',
                format: 'json',
                ...params
            })
    };
    invites = {
        /**
         * No description
         *
         * @tags invites
         * @name GetInvites
         * @request GET:/v3/invites
         * @secure
         */
        getInvites: (params: RequestParams = {}) =>
            this.request<
                GetInvitesResponse,
                UnauthorisedErrorResponse | TokenExpiredErrorResponse
            >({
                path: `/v3/invites`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags invites
         * @name AcceptInvite
         * @request POST:/v3/invites/{inviteId}/accept
         * @secure
         */
        acceptInvite: (inviteId: string, params: RequestParams = {}) =>
            this.request<
                AcceptInviteResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | InviteNotFoundErrorResponse
                      | UserNotFoundErrorResponse
                      | CompanyNotFoundErrorResponse
                  )
            >({
                path: `/v3/invites/${inviteId}/accept`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags invites
         * @name DeclineInvite
         * @request POST:/v3/invites/{inviteId}/decline
         * @secure
         */
        declineInvite: (inviteId: string, params: RequestParams = {}) =>
            this.request<
                void,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (InviteNotFoundErrorResponse | CompanyNotFoundErrorResponse)
            >({
                path: `/v3/invites/${inviteId}/decline`,
                method: 'POST',
                secure: true,
                ...params
            })
    };
    me = {
        /**
         * No description
         *
         * @tags me
         * @name GetMe
         * @request GET:/v3/me
         * @secure
         */
        getMe: (params: RequestParams = {}) =>
            this.request<
                GetMeResponse,
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | UserNotFoundErrorResponse
            >({
                path: `/v3/me`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Deletes the calling user's own account and revokes every session it holds. The deletion is reversible: the account is retained in a deleted state so the tasks, teams and history that reference it stay intact, and signing in again — by password or SSO — restores it as it was. The address is therefore not released for re-registration. Access tokens already issued keep working until they expire; the client should discard its tokens as soon as this returns. Calling it again on an already-deleted account is a no-op and still returns 200.
         *
         * @tags me
         * @name DeleteMe
         * @request DELETE:/v3/me
         * @secure
         */
        deleteMe: (params: RequestParams = {}) =>
            this.request<
                void,
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | UserNotFoundErrorResponse
            >({
                path: `/v3/me`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags me
         * @name UpdatePassword
         * @request POST:/v3/me/password
         * @secure
         */
        updatePassword: (
            data: UpdatePasswordRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetMeResponse,
                | (ValidationErrorResponse | IncorrectPasswordErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | UserNotFoundErrorResponse
            >({
                path: `/v3/me/password`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags me
         * @name UpdatePin
         * @request POST:/v3/me/pin
         * @secure
         */
        updatePin: (data: UpdatePinRequest, params: RequestParams = {}) =>
            this.request<
                GetMeResponse,
                | (ValidationErrorResponse | IncorrectPasswordErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | UserNotFoundErrorResponse
            >({
                path: `/v3/me/pin`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags me
         * @name ResendEmailVerification
         * @request POST:/v3/me/email/verify/resend
         * @secure
         */
        resendEmailVerification: (params: RequestParams = {}) =>
            this.request<
                void,
                | EmailAlreadyVerifiedErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | UserNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/me/email/verify/resend`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags me
         * @name RequestEmailChange
         * @request POST:/v3/me/email
         * @secure
         */
        requestEmailChange: (
            data: UpdateEmailRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetMeResponse,
                | (
                      | ValidationErrorResponse
                      | IncorrectPasswordErrorResponse
                      | EmailBlockedErrorResponse
                      | EmailAlreadyInUseErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | UserNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/me/email`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags me
         * @name UpsertAppDevice
         * @request PUT:/v3/me/app-devices
         * @secure
         */
        upsertAppDevice: (
            data: UpsertAppDeviceRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                void,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/me/app-devices`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            })
    };
    notifications = {
        /**
         * No description
         *
         * @tags notifications
         * @name GetNotifications
         * @request GET:/v3/notifications
         * @secure
         */
        getNotifications: (
            query?: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 25
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * Filter by read state. Does not affect `unreadCount`, which is always the total unread.
                 * @default "all"
                 */
                status?: 'all' | 'read' | 'unread';
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetNotificationsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/notifications`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags notifications
         * @name MarkNotificationsRead
         * @request POST:/v3/notifications/read
         * @secure
         */
        markNotificationsRead: (
            data: MarkNotificationsReadRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                MarkNotificationsReadResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/notifications/read`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags notifications
         * @name MarkAllNotificationsRead
         * @request POST:/v3/notifications/read/all
         * @secure
         */
        markAllNotificationsRead: (params: RequestParams = {}) =>
            this.request<
                MarkNotificationsReadResponse,
                UnauthorisedErrorResponse | TokenExpiredErrorResponse
            >({
                path: `/v3/notifications/read/all`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            })
    };
    subscriptions = {
        /**
         * No description
         *
         * @tags subscriptions
         * @name GetSubscriptionPrices
         * @request GET:/v3/subscriptions/prices
         * @secure
         */
        getSubscriptionPrices: (params: RequestParams = {}) =>
            this.request<
                GetPricesResponse,
                UnauthorisedErrorResponse | TokenExpiredErrorResponse
            >({
                path: `/v3/subscriptions/prices`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            })
    };
    tasks = {
        /**
         * No description
         *
         * @tags tasks
         * @name GetTasks
         * @request GET:/v3/tasks
         * @secure
         */
        getTasks: (
            query?: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 25
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /** The team ids */
                teamIds?: string[];
                /** The user ids */
                userIds?: string[];
                /** If true, userIds are treated as company user ids instead of user (account) ids. */
                useNewUserSystem?: boolean;
                /** The device ids */
                deviceIds?: string[];
                /** The task status. */
                status?: 'ACTIVE' | 'COMPLETED' | 'ALERTED';
                /** If true, only live tasks will be returned. */
                liveOnly?: boolean;
                /**
                 * Return all tasks on or after this date.
                 * @format date-time
                 */
                from?: string;
                /**
                 * Return all tasks on or before this date.
                 * @format date-time
                 */
                to?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetTasksResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/tasks`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name Create
         * @request POST:/v3/tasks
         * @secure
         */
        create: (data: CreateTaskRequest, params: RequestParams = {}) =>
            this.request<
                CreateTaskEventResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPinErrorResponse
                      | NotSubscribedErrorResponse
                      | NoLicenseErrorResponse
                  )
                | (TeamNotFoundErrorResponse | UserNotFoundErrorResponse)
            >({
                path: `/v3/tasks`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name GetTask
         * @request GET:/v3/tasks/{taskId}
         * @secure
         */
        getTask: (taskId: string, params: RequestParams = {}) =>
            this.request<
                GetTaskResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TaskNotFoundErrorResponse
            >({
                path: `/v3/tasks/${taskId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name GetEvents
         * @request GET:/v3/tasks/{taskId}/events
         * @secure
         */
        getEvents: (taskId: string, params: RequestParams = {}) =>
            this.request<
                GetTaskEventsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TaskNotFoundErrorResponse
            >({
                path: `/v3/tasks/${taskId}/events`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name GetInfo
         * @request GET:/v3/tasks/{taskId}/info
         * @secure
         */
        getInfo: (taskId: string, params: RequestParams = {}) =>
            this.request<
                GetTaskInfoResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TaskNotFoundErrorResponse
            >({
                path: `/v3/tasks/${taskId}/info`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name GetLocations
         * @request GET:/v3/tasks/{taskId}/locations
         * @secure
         */
        getLocations: (
            taskId: string,
            query?: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 5000
                 * @default 5000
                 */
                limit?: number;
                /**
                 * The ISO timestamp to start from
                 * @example "2021-01-01T00:00:00Z"
                 */
                fromTs?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetTaskLocationsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TaskNotFoundErrorResponse
            >({
                path: `/v3/tasks/${taskId}/locations`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name Extend
         * @request POST:/v3/tasks/{taskId}/extend
         * @secure
         */
        extend: (
            taskId: string,
            data: ExtendTaskRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                CreateTaskEventResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TaskNotActiveErrorResponse
                | (
                      | TaskNotFoundErrorResponse
                      | CompanyNotFoundErrorResponse
                      | UserNotFoundErrorResponse
                  )
            >({
                path: `/v3/tasks/${taskId}/extend`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name Complete
         * @request POST:/v3/tasks/{taskId}/complete
         * @secure
         */
        complete: (taskId: string, params: RequestParams = {}) =>
            this.request<
                CreateTaskEventResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TaskNotActiveErrorResponse
                | (
                      | TaskNotFoundErrorResponse
                      | CompanyNotFoundErrorResponse
                      | UserNotFoundErrorResponse
                  )
            >({
                path: `/v3/tasks/${taskId}/complete`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name AddNote
         * @request POST:/v3/tasks/{taskId}/notes
         * @secure
         */
        addNote: (
            taskId: string,
            data: AddTaskNoteRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                CreateTaskEventResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (TaskNotFoundErrorResponse | UserNotFoundErrorResponse)
            >({
                path: `/v3/tasks/${taskId}/notes`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name Assign
         * @request POST:/v3/tasks/{taskId}/assign
         * @secure
         */
        assign: (taskId: string, params: RequestParams = {}) =>
            this.request<
                CreateTaskEventResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (TaskNotAlertedErrorResponse | AlreadyAssignedErrorResponse)
                | (TaskNotFoundErrorResponse | UserNotFoundErrorResponse)
            >({
                path: `/v3/tasks/${taskId}/assign`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags tasks
         * @name Resolve
         * @request POST:/v3/tasks/{taskId}/resolve
         * @secure
         */
        resolve: (
            taskId: string,
            data: ResolveTaskRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                CreateTaskEventResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TaskNotAlertedErrorResponse
                | (TaskNotFoundErrorResponse | UserNotFoundErrorResponse)
            >({
                path: `/v3/tasks/${taskId}/resolve`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            })
    };
    teams = {
        /**
         * No description
         *
         * @tags teams
         * @name GetTeams
         * @request GET:/v3/teams
         * @secure
         */
        getTeams: (
            query?: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 200
                 * @default 50
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * Sort in ascending (A-Z, 1-9, 01/01/1970-Today) or descending (Z-A, 9-1, Today-01/01/1970) order
                 * @default "asc"
                 */
                sortOrder?: 'asc' | 'desc';
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /**
                 * Case-insensitive substring match on the team name.
                 * @example "north"
                 */
                search?: string;
                /** Filter by whether the team is connected to an alarm receiving centre. */
                arcEnabled?: boolean;
                /** Filter by whether the team requires a PIN. */
                pinEnabled?: boolean;
                /** Restrict the results to teams the requesting user is a member of — the teams they hold an entry for, whatever role that entry carries. Company owners and admins otherwise see every team in their company through their inherited team-admin role; this excludes the ones they hold no entry for. Narrows which teams match, not how `myTeamRoles` resolves a role. */
                myTeamsOnly?: boolean;
                /** Restrict the results to teams the requesting user holds one of these roles in, as shown in the response. `admin` includes the inherited team-admin role of company owners/admins, so they match every team in their company — including teams they are not a member of; `guardian` matches the requesting user's own team entry only. `memberOnly` means a team entry that carries no role at all, so a company owner/admin never matches it — to find the teams they belong to regardless of role, use `myTeamsOnly`. Intersected with the teams the requesting user may see — it never widens their scope. */
                myTeamRoles?: ('admin' | 'guardian' | 'memberOnly')[];
                /** Field to sort by. `name` sorts case-insensitively by team name. When omitted the list is in stable insertion order and sortOrder is ignored. */
                sortBy?: 'name';
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetTeamsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/teams`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags teams
         * @name CreateTeam
         * @request POST:/v3/teams
         * @secure
         */
        createTeam: (data: CreateTeamRequest, params: RequestParams = {}) =>
            this.request<
                CreateTeamResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CannotCreateTeamErrorResponse
                | (CompanyNotFoundErrorResponse | UserNotFoundErrorResponse)
            >({
                path: `/v3/teams`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags teams
         * @name GetTeamCounts
         * @request GET:/v3/teams/counts
         * @secure
         */
        getTeamCounts: (
            query: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetTeamCountsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/teams/counts`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags teams
         * @name GetTeam
         * @request GET:/v3/teams/{teamId}
         * @secure
         */
        getTeam: (teamId: string, params: RequestParams = {}) =>
            this.request<
                GetTeamResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TeamNotFoundErrorResponse
            >({
                path: `/v3/teams/${teamId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags teams
         * @name UpdateTeam
         * @request PATCH:/v3/teams/{teamId}
         * @secure
         */
        updateTeam: (
            teamId: string,
            data: UpdateTeamRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetTeamResponse,
                | (
                      | ValidationErrorResponse
                      | CannotEnableArcWithoutContactsErrorResponse
                      | CannotRemoveContactsWithArcEnabledErrorResponse
                      | CannotEnableOutOfHoursWithoutContactsErrorResponse
                      | CannotRemoveOutOfHoursContactsWhenEnabledErrorResponse
                      | InvalidTaskTimeSettingsErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CannotUpdateTeamErrorResponse
                | TeamNotFoundErrorResponse
            >({
                path: `/v3/teams/${teamId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags teams
         * @name DeleteTeam
         * @request DELETE:/v3/teams/{teamId}
         * @secure
         */
        deleteTeam: (teamId: string, params: RequestParams = {}) =>
            this.request<
                void,
                | (
                      | ValidationErrorResponse
                      | CannotRemoveLastTeamErrorResponse
                      | CannotRemoveTeamWithOpenTasksErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CannotRemoveTeamErrorResponse
                | TeamNotFoundErrorResponse
            >({
                path: `/v3/teams/${teamId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags teams
         * @name UploadTeamImage
         * @request POST:/v3/teams/{teamId}/image
         * @secure
         */
        uploadTeamImage: (
            teamId: string,
            data: {
                /** @format binary */
                file?: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetTeamResponse,
                | (
                      | ValidationErrorResponse
                      | FileRequiredErrorResponse
                      | CannotProcessFileErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CannotUpdateTeamErrorResponse
                | TeamNotFoundErrorResponse
            >({
                path: `/v3/teams/${teamId}/image`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            })
    };
    troubleshoot = {
        /**
         * No description
         *
         * @tags troubleshoot
         * @name SendPushNotification
         * @request POST:/v3/troubleshoot/send-push-notification
         * @secure
         */
        sendPushNotification: (
            data: SendTestPushNotificationRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                void,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | UserNotFoundErrorResponse
                      | UserDeviceNotFoundErrorResponse
                      | UserDeviceFcmNotFoundErrorResponse
                  )
            >({
                path: `/v3/troubleshoot/send-push-notification`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            })
    };
    users = {
        /**
         * No description
         *
         * @tags users
         * @name GetUsers
         * @request GET:/v3/users
         * @secure
         */
        getUsers: (
            query?: {
                /**
                 * The number of results to return
                 * @format int32
                 * @min 1
                 * @max 100
                 * @default 25
                 */
                limit?: number;
                /**
                 * The number of results to skip
                 * @format int32
                 * @min 0
                 * @default 0
                 */
                offset?: number;
                /**
                 * Sort in ascending (A-Z, 1-9, 01/01/1970-Today) or descending (Z-A, 9-1, Today-01/01/1970) order
                 * @default "asc"
                 */
                sortOrder?: 'asc' | 'desc';
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /**
                 * Restrict the results to users in these teams. Intersected with the users the requesting user may see - it never widens their scope.
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                teamIds?: string[];
                /**
                 * Exclude users who are in any of these teams. Users in none of them (including users on no team) are returned.
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                excludeTeamIds?: string[];
                /** Filter by whether the user is in any team at all. `false` returns users on no team. Applied alongside `teamIds`/`excludeTeamIds`, so `hasTeam=false` combined with `teamIds` matches nobody. */
                hasTeam?: boolean;
                /** Filter by team role, as shown in the response: `admin` includes the inherited team-admin role of company owners/admins, and `memberOnly` means a team entry that carries no role at all, so a company owner/admin never matches it. When `teamIds` is given the role must be held within those teams; otherwise any team counts. Users on no team never match. */
                teamRoles?: ('admin' | 'guardian' | 'memberOnly')[];
                /**
                 * Filter by membership status. `joined` returns users who have accepted their invite; `invited` returns users who have not joined yet, including those who declined (see `hasDeclinedInvite`).
                 * @default "all"
                 */
                membership?: 'all' | 'joined' | 'invited';
                /** Filter by company role. Matches the derived role returned in the response, so a user matches exactly one role. */
                roles?: ('owner' | 'admin' | 'billing' | 'member')[];
                /**
                 * Case-insensitive substring match on first name, last name or email.
                 * @example "north"
                 */
                search?: string;
                /** Field to sort by. `name` sorts by first then last name, with nameless users (e.g. pending invites) always last; `role` by role seniority (owner > admin > billing > member); `teamRole` by the best team role held (admin, including inherited > guardian > no role > no team; scoped to `teamIds` when given); `teams` by the number of teams; `license` by whether the user has a license (regardless of its validity dates). When omitted the list is in stable insertion order and sortOrder is ignored. */
                sortBy?: 'name' | 'role' | 'teamRole' | 'teams' | 'license';
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetUsersPaginatedResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/users`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Deprecated. Returns every company user in a single response, and receives no new list features — use the paginated `GET /v3/users`, which supports filtering, sorting, search and pagination.
         *
         * @tags users
         * @name GetUsersUnpaginated
         * @request GET:/v3/users/unpaginated
         * @deprecated
         * @secure
         */
        getUsersUnpaginated: (
            query?: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId?: string;
                /**
                 * The team id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                teamId?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetCompanyUsersResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
            >({
                path: `/v3/users/unpaginated`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name GetUserCounts
         * @request GET:/v3/users/counts
         * @secure
         */
        getUserCounts: (
            query: {
                /**
                 * The company id
                 * @example "6315a5ed4c8edd17c30b2dc9"
                 */
                companyId: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserCountsResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/counts`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name InviteUsers
         * @request POST:/v3/users/invites
         * @secure
         */
        inviteUsers: (
            data: CreateCompanyUserInvitesRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetCompanyUsersResponse,
                | (
                      | ValidationErrorResponse
                      | CannotInviteUsersWithOwnerErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | NoPermissionErrorResponse
                      | UserAlreadyInvitedOrJoinedErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | (
                      | CompanyNotFoundErrorResponse
                      | CompanyUserNotFoundErrorResponse
                      | TeamNotFoundErrorResponse
                  )
            >({
                path: `/v3/users/invites`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name GetUser
         * @request GET:/v3/users/{userId}
         * @secure
         */
        getUser: (userId: string, params: RequestParams = {}) =>
            this.request<
                GetUserResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name DeleteUser
         * @request DELETE:/v3/users/{userId}
         * @secure
         */
        deleteUser: (userId: string, params: RequestParams = {}) =>
            this.request<
                void,
                | (
                      | ValidationErrorResponse
                      | CannotRemoveUserWithOpenTasksErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name UpdateUser
         * @request PATCH:/v3/users/{userId}
         * @secure
         */
        updateUser: (
            userId: string,
            data: UpdateCompanyUserRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name GetUserAppDevices
         * @request GET:/v3/users/{userId}/app-devices
         * @secure
         */
        getUserAppDevices: (userId: string, params: RequestParams = {}) =>
            this.request<
                GetUserAppDevicesResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/app-devices`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name UploadUserImage
         * @request POST:/v3/users/{userId}/image
         * @secure
         */
        uploadUserImage: (
            userId: string,
            data: {
                /** @format binary */
                file?: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | (
                      | ValidationErrorResponse
                      | FileRequiredErrorResponse
                      | CannotProcessFileErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/image`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name AddUserPhone
         * @request POST:/v3/users/{userId}/phone
         * @secure
         */
        addUserPhone: (
            userId: string,
            data: AddPhoneRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (AppCheckErrorResponse | ForbiddenUnauthorisedErrorResponse)
                | CompanyUserNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/users/${userId}/phone`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name DeleteUserPhone
         * @request DELETE:/v3/users/{userId}/phone
         * @secure
         */
        deleteUserPhone: (userId: string, params: RequestParams = {}) =>
            this.request<
                GetUserResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/phone`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name VerifyUserPhone
         * @request POST:/v3/users/{userId}/phone/verify
         * @secure
         */
        verifyUserPhone: (
            userId: string,
            data: VerifyPhoneRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | (ValidationErrorResponse | IncorrectCodeErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (AppCheckErrorResponse | ForbiddenUnauthorisedErrorResponse)
                | CompanyUserNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/users/${userId}/phone/verify`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name AddUserPhone2
         * @request POST:/v3/users/{userId}/phone2
         * @secure
         */
        addUserPhone2: (
            userId: string,
            data: AddPhoneRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (AppCheckErrorResponse | ForbiddenUnauthorisedErrorResponse)
                | CompanyUserNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/users/${userId}/phone2`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name DeleteUserPhone2
         * @request DELETE:/v3/users/{userId}/phone2
         * @secure
         */
        deleteUserPhone2: (userId: string, params: RequestParams = {}) =>
            this.request<
                GetUserResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/phone2`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name VerifyUserPhone2
         * @request POST:/v3/users/{userId}/phone2/verify
         * @secure
         */
        verifyUserPhone2: (
            userId: string,
            data: VerifyPhoneRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | (ValidationErrorResponse | IncorrectCodeErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (AppCheckErrorResponse | ForbiddenUnauthorisedErrorResponse)
                | CompanyUserNotFoundErrorResponse
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/users/${userId}/phone2/verify`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name UpdateUserRoles
         * @request PATCH:/v3/users/{userId}/roles
         * @secure
         */
        updateUserRoles: (
            userId: string,
            data: UpdateUserCompanyRolesRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | (ValidationErrorResponse | CannotRemoveLastOwnerErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | ForbiddenUnauthorisedErrorResponse
                      | CannotAssignOwnerRoleErrorResponse
                  )
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/roles`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name UpdateUserLicense
         * @request PATCH:/v3/users/{userId}/licenses
         * @secure
         */
        updateUserLicense: (
            userId: string,
            data: UpdateUserCompanyLicenseRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | ForbiddenUnauthorisedErrorResponse
                      | NotSubscribedErrorResponse
                      | NoMoreLicensesErrorResponse
                  )
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/licenses`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name ResendUserInvite
         * @request POST:/v3/users/{userId}/invites/resend
         * @secure
         */
        resendUserInvite: (userId: string, params: RequestParams = {}) =>
            this.request<
                void,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | (
                      | ForbiddenUnauthorisedErrorResponse
                      | UserAlreadyJoinedErrorResponse
                  )
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/invites/resend`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name AddUserToTeam
         * @request POST:/v3/users/{userId}/teams
         * @secure
         */
        addUserToTeam: (
            userId: string,
            data: CreateTeamUserRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | (ValidationErrorResponse | UserAlreadyInTeamErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | (CompanyUserNotFoundErrorResponse | TeamNotFoundErrorResponse)
            >({
                path: `/v3/users/${userId}/teams`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name UpdateUserTeamRoles
         * @request PATCH:/v3/users/{userId}/teams/{teamId}/roles
         * @secure
         */
        updateUserTeamRoles: (
            userId: string,
            teamId: string,
            data: UpdateUserTeamRolesRequest,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | (ValidationErrorResponse | UserNotInTeamErrorResponse)
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | CompanyUserNotFoundErrorResponse
            >({
                path: `/v3/users/${userId}/teams/${teamId}/roles`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags users
         * @name RemoveUserFromTeam
         * @request DELETE:/v3/users/{userId}/teams/{teamId}
         * @secure
         */
        removeUserFromTeam: (
            userId: string,
            teamId: string,
            params: RequestParams = {}
        ) =>
            this.request<
                GetUserResponse,
                | (
                      | ValidationErrorResponse
                      | UserNotInTeamErrorResponse
                      | CannotRemoveUserWithOpenTasksErrorResponse
                  )
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | ForbiddenUnauthorisedErrorResponse
                | (CompanyUserNotFoundErrorResponse | TeamNotFoundErrorResponse)
            >({
                path: `/v3/users/${userId}/teams/${teamId}`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params
            })
    };
    w3W = {
        /**
         * No description
         *
         * @tags w3w
         * @name GetW3W
         * @request GET:/v3/w3w
         * @secure
         */
        getW3W: (
            query: {
                /**
                 * The latitude.
                 * @example 0
                 */
                lat: number;
                /**
                 * The longitude.
                 * @example 0
                 */
                lng: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<
                GetW3WResponse,
                | ValidationErrorResponse
                | (UnauthorisedErrorResponse | TokenExpiredErrorResponse)
                | TooManyRequestsErrorResponse
            >({
                path: `/v3/w3w`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            })
    };
}
